/* eslint-disable max-len */
import React from 'react'
import IconBase from 'react-icon-base'

export const makeIcon = ({
  displayName = 'Icon',
  viewBox = 16,
  content,
  viewBoxWidth = viewBox,
  viewBoxHeight = viewBox,
}) => {
  const IconComponent = props => {
    const { color, hGradient, ...otherProps } = props
    return (
      <IconBase
        xmlns="http://www.w3.org/2000/svg"
        viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
        {...otherProps}
      >
        {hGradient && (
          <linearGradient
            x1="100%"
            y1="100%"
            x2="0%"
            y2="0%"
            id="linearGradient-1"
          >
            <stop stopColor={hGradient.startColor} offset="0%" />
            <stop stopColor={hGradient.endColor} offset="100%" />
          </linearGradient>
        )}
        <g
          fill={hGradient ? 'url(#linearGradient-1)' : color || 'currentColor'}
        >
          {content}
        </g>
      </IconBase>
    )
  }
  IconComponent.displayName = displayName
  return React.memo(IconComponent)
}

export const ActivityEmptyIcon = makeIcon({
  displayName: 'ActivityEmptyIcon',
  content: (
    <g>
      <path d="M3.8 7h2.3c.5 0 1 .4 1 .9l.3 4.3L10.5 8H9c-.6 0-1.1-.6-1-1.2L9.2 2H5.1L3.8 7zm1.3 2H2.5c-.7 0-1.1-.6-1-1.3l1.9-7c.1-.4.5-.7 1-.7h6.1c.6 0 1.1.6 1 1.2L10.3 6h2.2c.8 0 1.3.9.8 1.6l-6 8c-.6.7-1.7.4-1.8-.5L5.1 9z" />
    </g>
  ),
})

export const ActivityIcon = makeIcon({
  displayName: 'ActivityIcon',
  content: (
    <g>
      <path d="M5.6 9H3c-.7 0-1.1-.6-1-1.3l1.9-7c.1-.4.5-.7 1-.7H11c.6 0 1.1.6 1 1.2L10.8 6H13c.8 0 1.3.9.8 1.6l-6 8c-.5.7-1.7.4-1.8-.5L5.6 9z" />
    </g>
  ),
})

export const AddIcon = makeIcon({
  displayName: 'AddIcon',
  viewBox: 12,
  content: (
    <g fillRule="evenodd" clipRule="evenodd">
      <path d="M5.25 5.25V0.75C5.25 0.335786 5.58579 0 6 0C6.41421 0 6.75 0.335786 6.75 0.75V5.25H11.25C11.6642 5.25 12 5.58579 12 6C12 6.41421 11.6642 6.75 11.25 6.75H6.75V11.25C6.75 11.6642 6.41421 12 6 12C5.58579 12 5.25 11.6642 5.25 11.25V6.75H0.75C0.335786 6.75 0 6.41421 0 6C0 5.58579 0.335786 5.25 0.75 5.25H5.25Z" />
    </g>
  ),
})

export const AddPermissionIcon = makeIcon({
  displayName: 'AddPermission',
  content: (
    <g fillRule="evenodd" clipRule="evenodd">
      <path d="M8,14 C11.31365,14 14,11.31365 14,8 C14,4.68629 11.31365,2 8,2 C4.68629,2 2,4.68629 2,8 C2,11.31365 4.68629,14 8,14 Z M8,16 C12.4182667,16 16,12.4182667 16,8 C16,3.58172 12.4182667,0 8,0 C3.58172,0 0,3.58172 0,8 C0,12.4182667 3.58172,16 8,16 Z" />
      <path d="M7.25,5.75 C7.25,5.33579 7.5857675,5 8,5 C8.4142325,5 8.75,5.33579 8.75,5.75 L8.75,7.25 L10.25,7.25 C10.664225,7.25 11,7.5857825 11,8 C11,8.4142175 10.664225,8.75 10.25,8.75 L8.75,8.75 L8.75,10.25 C8.75,10.664225 8.4142325,11 8,11 C7.5857675,11 7.25,10.664225 7.25,10.25 L7.25,8.75 L5.75,8.75 C5.3357675,8.75 5,8.4142175 5,8 C5,7.5857825 5.3357675,7.25 5.75,7.25 L7.25,7.25 L7.25,5.75 Z" />
    </g>
  ),
})

export const AddUserIcon = makeIcon({
  displayName: 'AddUser',
  content: (
    <path d="M13.4,11.6h1.8c0.5,0,0.9,0.4,0.9,0.9s-0.4,0.9-0.9,0.9h-1.8v1.8c0,0.5-0.4,0.9-0.9,0.9 s-0.9-0.4-0.9-0.9v-1.8H9.9C9.4,13.4,9,13,9,12.5s0.4-0.9,0.9-0.9h1.8V9.9C11.6,9.4,12,9,12.5,9s0.9,0.4,0.9,0.9V11.6z M8,8 C5.8,8,4,6.2,4,4s1.8-4,4-4s4,1.8,4,4S10.2,8,8,8z M8,6c1.1,0,2-0.9,2-2S9.1,2,8,2S6,2.9,6,4S6.9,6,8,6z M8,11H3.5 C2.7,11,2,11.7,2,12.5V13c0,0.6,0.4,1,1,1h5c0.6,0,1,0.4,1,1s-0.4,1-1,1H3c-1.7,0-3-1.3-3-3v-0.5C0,10.6,1.6,9,3.5,9H8 c0.6,0,1,0.4,1,1C9,10.6,8.6,11,8,11z" />
  ),
})

export const AllNotesIcon = makeIcon({
  displayName: 'AllNotesIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 10C12 10.5523 12.4477 11 13 11C14.6569 11 16 9.65685 16 8V3C16 1.34315 14.6569 0 13 0H8C6.34315 0 5 1.34315 5 3C5 3.55196 5.44745 3.99941 5.99941 3.99941H6.03229C6.58425 3.99941 7.0317 3.55196 7.0317 3C7.0317 3 6.94603 1.98127 8 1.98127H13C13 1.98127 14.0393 2.00059 14.0393 3V8C14.0393 8 14.0093 9 13 9C12.4477 9 12 9.44771 12 10ZM3 5H8C9.65685 5 11 6.34315 11 8V13C11 14.6569 9.65685 16 8 16H3C1.34315 16 0 14.6569 0 13V8C0 6.34315 1.34315 5 3 5ZM2 8C2 7.44772 2.44772 7 3 7H8C8.55228 7 9 7.44772 9 8V13C9 13.5523 8.55228 14 8 14H3C2.44772 14 2 13.5523 2 13V8Z"
    />
  ),
})

export const AllPanelsIcon = makeIcon({
  displayName: 'AllPanelsIcon',
  viewBoxHeight: 16,
  viewBoxWidth: 19,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 3C0 1.34315 1.34315 0 3 0H16C17.6569 0 19 1.34315 19 3V13C19 14.6569 17.6569 16 16 16H3C1.34315 16 0 14.6569 0 13V3ZM4 2V14H6V2H4ZM16 14H8V2H16C16.5523 2 17 2.44772 17 3V13C17 13.5523 16.5523 14 16 14ZM10 5C10 4.44772 10.4477 4 11 4H13C13.5523 4 14 4.44772 14 5C14 5.55228 13.5523 6 13 6H11C10.4477 6 10 5.55228 10 5ZM11 7.5C10.4477 7.5 10 7.94772 10 8.5C10 9.05229 10.4477 9.5 11 9.5H14C14.5523 9.5 15 9.05229 15 8.5C15 7.94772 14.5523 7.5 14 7.5H11Z"
      />
    </g>
  ),
})

export const AnalyticsIcon = makeIcon({
  displayName: 'AnalyticsIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.636 1.478a1 1 0 01.136 1.408l-7 8.5a1 1 0 01-1.22.259l-3.17-1.586-2.524 4.206a1 1 0 11-1.715-1.03l3-5a1 1 0 011.304-.38L7.735 9.5l6.493-7.885a1 1 0 011.408-.136z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.671 1.509A1 1 0 0116 2.25v5a1 1 0 11-2 0V3.355l-3.9.39a1 1 0 11-.2-1.99l5-.5a1 1 0 01.771.254z"
      />
    </g>
  ),
})

export const ArcBottomLeftIcon = makeIcon({
  displayName: 'ArcBottomLeftIcon',
  content: (
    <path d="M14 13.9999V7.96166C13.9873 7.96174 13.9745 7.96178 13.9618 7.96178C10.6903 7.96178 8.03822 5.3097 8.03822 2.03821C8.03822 2.02546 8.03826 2.01273 8.03834 2H2.00006C2.00002 2.01273 2 2.02547 2 2.03822C2 8.64453 7.35547 14 13.9618 14C13.9745 14 13.9873 14 14 13.9999Z" />
  ),
})

export const ArchiveIcon = makeIcon({
  displayName: 'ArchiveIcon',
  content: (
    <g>
      <path d="M6 9h4a1 1 0 1 1 0 2H6a1 1 0 1 1 0-2z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0a2 2 0 0 1 2 2v1.268A2 2 0 0 1 15 5v1.268A2 2 0 0 1 16 8v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8a2 2 0 0 1 1-1.732V5a2 2 0 0 1 1-1.732V2a2 2 0 0 1 2-2h8zM4 3h8V2H4v1zM3 6h10V5H3v1zM2 8v6h12V8H2z"
        fill="currentColor"
      />
    </g>
  ),
})

export const ArcTopRightIcon = makeIcon({
  displayName: 'ArcTopRightIcon',
  content: (
    <path d="M2 2.00006L2 8.03836C2.01273 8.03828 2.02547 8.03824 2.03823 8.03824C5.30972 8.03824 7.96179 10.6903 7.96179 13.9618C7.96179 13.9745 7.96175 13.9873 7.96167 14L13.9999 14C14 13.9873 14 13.9745 14 13.9618C14 7.35547 8.64453 2 2.03822 2C2.02547 2 2.01273 2.00002 2 2.00006Z" />
  ),
})
//Legacy?
export const ArobaseIcon = makeIcon({
  displayName: 'ArobaseIcon',
  content: (
    <g>
      <path d="M4.08201 8.12106C4.08201 10.4254 5.71622 12.0646 7.90201 12.0646C8.92924 12.0646 9.76861 11.6403 10.3221 11.0655C10.7395 11.6871 11.4558 12.0646 12.366 12.0646C14.4414 12.0646 15.664 10.3377 15.664 7.36553C15.664 3.27717 12.6049 0.219999 8.11801 0.219999C3.63547 0.219999 0.338013 3.57778 0.338013 8.0491C0.338013 12.464 3.68735 15.7883 7.99201 15.7883C9.21314 15.7883 10.2471 15.5825 11.0976 15.2372C11.6202 15.025 11.971 14.8071 12.1564 14.6503C12.3071 14.5229 12.3422 14.3047 12.2392 14.1364L11.6992 13.255C11.582 13.0638 11.3304 13.0062 11.1417 13.1275C10.3536 13.6339 9.30584 13.8914 7.99201 13.8914C4.70355 13.8914 2.38001 11.4461 2.38001 8.03111C2.38001 4.65704 4.7645 2.09882 8.10001 2.09882C11.4863 2.09882 13.658 4.23115 13.658 7.38352C13.658 9.27262 13.1539 10.1858 12.456 10.1858C11.9524 10.1858 11.758 9.93418 11.758 9.27234V5.28783C11.758 4.73423 11.309 4.28546 10.755 4.28546C10.3775 4.28546 10.0487 4.49389 9.87755 4.80189C9.36606 4.43126 8.67899 4.17752 7.86601 4.17752C5.71648 4.17752 4.08201 5.83499 4.08201 8.12106ZM7.99201 10.1495C6.92859 10.1495 6.17801 9.34826 6.17801 8.12079C6.17801 6.89598 6.92618 6.11004 7.97401 6.11004C9.08533 6.11004 9.80601 6.8844 9.80601 8.08481C9.80601 9.39499 9.06339 10.1495 7.99201 10.1495Z" />
    </g>
  ),
})

export const ArrowLeftIcon = makeIcon({
  displayName: 'ArrowLeftIcon',
  content: (
    <path d="M6.53712 5.87868C6.92765 5.48816 6.92765 4.85499 6.53712 4.46447C6.1466 4.07394 5.51343 4.07394 5.12291 4.46447L2.36 7.22738C2.14 7.41081 2 7.68695 2 7.99578C2 8.12256 2.02359 8.24383 2.06662 8.35544C2.11528 8.48364 2.19123 8.60386 2.29448 8.70711L5.12291 11.5355C5.51343 11.9261 6.1466 11.9261 6.53712 11.5355C6.92765 11.145 6.92765 10.5118 6.53712 10.1213L5.41159 8.99578H13C13.5523 8.99578 14 8.54807 14 7.99578C14 7.4435 13.5523 6.99578 13 6.99578H5.42002L6.53712 5.87868Z" />
  ),
})

export const ArrowRightIcon = makeIcon({
  displayName: 'ArrowRightIcon',
  content: (
    <path d="M9.46288 10.1213C9.07235 10.5118 9.07235 11.145 9.46288 11.5355C9.8534 11.9261 10.4866 11.9261 10.8771 11.5355L13.64 8.77263C13.86 8.58919 14 8.31306 14 8.00422C14 7.87745 13.9764 7.75618 13.9334 7.64458C13.8847 7.51637 13.8088 7.39615 13.7055 7.2929L10.8771 4.46447C10.4866 4.07394 9.8534 4.07394 9.46288 4.46447C9.07235 4.85499 9.07235 5.48816 9.46288 5.87868L10.5884 7.00422L3 7.00422C2.44772 7.00422 2 7.45193 2 8.00422C2 8.5565 2.44772 9.00422 3 9.00422L10.58 9.00422L9.46288 10.1213Z" />
  ),
})

export const ArrowUpIcon = makeIcon({
  displayName: 'ArrowUpIcon',
  viewBox: 12,
  content: (
    <path d="M7.93934 5.25122C8.23223 5.54412 8.7071 5.54412 9 5.25122C9.29289 4.95833 9.29289 4.48346 9 4.19056L6.57946 1.77C6.44188 1.605 6.23478 1.5 6.00315 1.5C5.90807 1.5 5.81712 1.51769 5.73342 1.54997C5.63726 1.58646 5.5471 1.64342 5.46966 1.72086L2.99998 4.19056C2.70709 4.48345 2.70709 4.95833 2.99998 5.25122C3.29287 5.54411 3.76775 5.54411 4.06064 5.25122L5.25315 4.0587L5.25315 9.75C5.25315 10.1642 5.58894 10.5 6.00315 10.5C6.41736 10.5 6.75315 10.1642 6.75315 9.75L6.75315 4.06502L7.93934 5.25122Z" />
  ),
})

export const RecycleIcon = makeIcon({
  displayName: 'Recycle',
  content: (
    <path d="M8.6024 2.25C7.8548 2.25 7.14444 2.3986 6.49734 2.66694C5.82374 2.94627 5.21676 3.3562 4.70842 3.8658C4.43705 4.13785 4.19415 4.43796 3.98441 4.76124C3.68382 5.22456 3.10577 5.47346 2.59561 5.26191C2.08545 5.05035 1.83783 4.46087 2.11553 3.98348C2.4416 3.42297 2.838 2.90894 3.29245 2.45336C3.98386 1.76021 4.81086 1.20115 5.73124 0.81949C6.61693 0.452212 7.58731 0.25 8.6024 0.25C9.61749 0.25 10.5879 0.452212 11.4736 0.819492C12.391 1.19993 13.2156 1.75663 13.9057 2.44669C14.3691 2.91005 14.7723 3.43409 15.1024 4.00616V1.75C15.1024 1.19772 15.5501 0.75 16.1024 0.75C16.6547 0.75 17.1024 1.19772 17.1024 1.75V6.75C17.1024 7.30228 16.6547 7.75 16.1024 7.75H11.1024C10.5501 7.75 10.1024 7.30228 10.1024 6.75C10.1024 6.19771 10.5501 5.75 11.1024 5.75H13.7363C13.7175 5.71639 13.7006 5.68136 13.6855 5.64496C13.407 4.97351 12.9988 4.36825 12.4915 3.86091C11.9841 3.35358 11.3789 2.94538 10.7075 2.66694C10.0603 2.3986 9.34999 2.25 8.6024 2.25ZM9.39765 13.75C10.1452 13.75 10.8556 13.6014 11.5027 13.3331C12.1763 13.0537 12.7833 12.6438 13.2916 12.1342C13.563 11.8621 13.8059 11.562 14.0156 11.2388C14.3162 10.7754 14.8943 10.5265 15.4044 10.7381C15.9146 10.9496 16.1622 11.5391 15.8845 12.0165C15.5584 12.577 15.162 13.0911 14.7076 13.5466C14.0162 14.2398 13.1892 14.7988 12.2688 15.1805C11.3831 15.5478 10.4127 15.75 9.39765 15.75C8.38256 15.75 7.41217 15.5478 6.52648 15.1805C5.60905 14.8001 4.78441 14.2434 4.09435 13.5533C3.63099 13.0899 3.22776 12.5659 2.89764 11.9938V14.25C2.89764 14.8023 2.44993 15.25 1.89764 15.25C1.34536 15.25 0.897644 14.8023 0.897644 14.25V9.25C0.897644 8.69771 1.34536 8.25 1.89764 8.25L6.89764 8.25C7.44993 8.25 7.89764 8.69771 7.89764 9.25C7.89764 9.80228 7.44993 10.25 6.89764 10.25H4.26376C4.28249 10.2836 4.29949 10.3186 4.31458 10.355C4.59302 11.0265 5.00122 11.6317 5.50856 12.1391C6.0159 12.6464 6.62115 13.0546 7.29259 13.3331C7.93969 13.6014 8.65005 13.75 9.39765 13.75Z" />
  ),
})

export const BillingIcon = makeIcon({
  displayName: 'Billing',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 11C0 12.6569 1.34315 14 3 14L13 14C14.6569 14 16 12.6569 16 11V5C16 3.34315 14.6569 2 13 2L3 2C1.34315 2 0 3.34315 0 5V11ZM3 12C2.44772 12 2 11.5523 2 11L2 8H14V11C14 11.5523 13.5523 12 13 12L3 12ZM14 5.5V5C14 4.44771 13.5523 4 13 4L3 4C2.44772 4 2 4.44772 2 5L2 5.5H14Z"
    />
  ),
})

export const BoldIcon = makeIcon({
  displayName: 'BoldIcon',
  content: (
    <g>
      <path d="M6 7C6.8721 7 7.81264 7 8.75 7C10.1307 7 11.25 5.88071 11.25 4.5C11.25 3.11929 10.1307 2 8.75001 2C7.81264 2 6.8721 2 6 2V7ZM6 14C6.9618 14 8.25663 14 9.50011 14C10.8808 14 12 12.8807 12 11.5C12 10.1193 10.8808 9 9.50011 9C8.25663 9 6.9618 9 6 9V14ZM8.87014 16H4H3C2.44772 16 2 15.5523 2 15C2 14.4477 2.44772 14 3 14C3.33333 14 3.66667 14 4 14V2C3.69803 2 3.39606 2 3.09409 2C2.57656 2 2.14454 1.60513 2.09812 1.08968C2.04542 0.504362 2.5064 0 3.09409 0H3.81991H8.1763C8.44868 0 8.71685 0 8.97898 0C11.3379 0 13.25 1.91232 13.25 4.27128V4.73444C13.25 5.98081 12.5822 7.13163 11.5 7.75C13.0099 8.35397 14 9.81649 14 11.4427C14 11.521 14 11.5991 14 11.677C14 14.0646 12.0645 16 9.67689 16H8.87014Z" />
    </g>
  ),
})

export const BulletListIcon = makeIcon({
  displayName: 'BulletListIcon',
  content: (
    <g>
      <path d="M0 3C0 4.10457 0.89543 5 2 5C3.10457 5 4 4.10457 4 3C4 1.89543 3.10457 1 2 1C0.89543 1 0 1.89543 0 3ZM0 8C0 9.10457 0.89543 10 2 10C3.10457 10 4 9.10457 4 8C4 6.89543 3.10457 6 2 6C0.89543 6 0 6.89543 0 8ZM2 15C0.89543 15 0 14.1046 0 13C0 11.8954 0.89543 11 2 11C3.10457 11 4 11.8954 4 13C4 14.1046 3.10457 15 2 15ZM6 2C5.44772 2 5 2.44772 5 3C5 3.55228 5.44771 4 6 4H15C15.5523 4 16 3.55228 16 3C16 2.44772 15.5523 2 15 2H6ZM5 8C5 7.44772 5.44772 7 6 7H15C15.5523 7 16 7.44772 16 8C16 8.55228 15.5523 9 15 9H6C5.44771 9 5 8.55228 5 8ZM6 12C5.44772 12 5 12.4477 5 13C5 13.5523 5.44771 14 6 14H15C15.5523 14 16 13.5523 16 13C16 12.4477 15.5523 12 15 12H6Z" />
    </g>
  ),
})

export const BurgerMenuIcon = makeIcon({
  displayName: 'BurgerMenuIcon',
  content: (
    <g fill="currentColor">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.10352e-05 1.75C6.10352e-05 1.33579 0.335847 1 0.750061 1L11.2501 1C11.6643 1 12.0001 1.33579 12.0001 1.75C12.0001 2.16421 11.6643 2.5 11.2501 2.5L0.750061 2.5C0.335847 2.5 6.10352e-05 2.16421 6.10352e-05 1.75Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.11007e-05 6C6.10645e-05 5.58579 0.335847 5.25 0.750061 5.25L11.2501 5.25C11.6643 5.25 12.0001 5.58579 12.0001 6C12.0001 6.41421 11.6643 6.75 11.2501 6.75L0.750061 6.75C0.335848 6.75 6.11369e-05 6.41421 6.11007e-05 6Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.10352e-05 10.25C6.10352e-05 9.83579 0.335847 9.5 0.750061 9.5H7.25006C7.66427 9.5 8.00006 9.83579 8.00006 10.25C8.00006 10.6642 7.66427 11 7.25006 11H0.750061C0.335847 11 6.10352e-05 10.6642 6.10352e-05 10.25Z"
      />
    </g>
  ),
})

export const CalendarIcon = makeIcon({
  displayName: 'CalendarIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 0a1 1 0 0 1 1 1v.5h4V1a1 1 0 1 1 2 0v.5h1a3 3 0 0 1 3 3V13a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V4.5a3 3 0 0 1 3-3h1V1a1 1 0 0 1 1-1zm5 3.5v.497a1 1 0 1 0 2 0V3.5h1a1 1 0 0 1 1 1v1.494L2 6V4.5a1 1 0 0 1 1-1h1v.497a1 1 0 1 0 2 0V3.5h4zM2 8v5a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7.994L2 8zm2 2.993a1 1 0 0 1 1-1h1a1 1 0 0 1 0 2H5a1 1 0 0 1-1-1zm6-1a1 1 0 0 0 0 2h1a1 1 0 1 0 0-2h-1z"
      />
    </g>
  ),
})

export const CaretBottomIcon = makeIcon({
  displayName: 'CaretBottomIcon',
  content: (
    <path d="M11,7.3l-2.3,2.9c-0.3,0.3-0.8,0.4-1.1,0.1c0,0-0.1-0.1-0.1-0.1L5,7.3C4.8,7,4.8,6.5,5.2,6.2 C5.3,6.1,5.5,6,5.7,6h4.7c0.4,0,0.8,0.4,0.8,0.8C11.1,7,11.1,7.2,11,7.3z" />
  ),
})

export const CaretNavigationRightIcon = makeIcon({
  displayName: 'CaretNavigationRightIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 5.1105C5 4.18108 6.10668 3.66437 6.85376 4.24497L10.5718 7.13447C11.1427 7.5782 11.1427 8.4218 10.5718 8.86553L6.85376 11.755C6.10668 12.3356 5 11.8189 5 10.8895V5.1105Z"
    />
  ),
})

export const ChannelAddIcon = makeIcon({
  displayName: 'ChannelHasActivityIcon',
  viewBox: 16,
  content: (
    <>
      <path d="M11 4.75L8 4.75C7.44771 4.75 7 5.19772 7 5.75C7 6.30229 7.44772 6.75 8 6.75L11 6.75C11.5523 6.75 12 6.30228 12 5.75C12 5.19771 11.5523 4.75 11 4.75Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 0H12.5C14.1569 0 15.5 1.34315 15.5 3V7H13.5V3C13.5 2.44772 13.0523 2 12.5 2H5.5L5.5 14H7V16H3.5C1.84315 16 0.5 14.6569 0.5 13V3C0.5 1.34314 1.84315 0 3.5 0ZM3.5 14V2C2.94772 2 2.5 2.44772 2.5 3V13C2.5 13.5523 2.94772 14 3.5 14Z"
      />
      <path d="M8 15C8 15.5523 7.55228 16 7 16C6.44772 16 6 15.5523 6 15C6 14.4477 6.44772 14 7 14C7.55228 14 8 14.4477 8 15Z" />
      <path d="M15.5 7C15.5 7.55228 15.0523 8 14.5 8C13.9477 8 13.5 7.55228 13.5 7C13.5 6.44772 13.9477 6 14.5 6C15.0523 6 15.5 6.44772 15.5 7Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 9C13.0523 9 13.5 9.44772 13.5 10V15C13.5 15.5523 13.0523 16 12.5 16C11.9477 16 11.5 15.5523 11.5 15V10C11.5 9.44772 11.9477 9 12.5 9Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 12.5C16 13.0523 15.5523 13.5 15 13.5H10C9.44772 13.5 9 13.0523 9 12.5C9 11.9477 9.44772 11.5 10 11.5H15C15.5523 11.5 16 11.9477 16 12.5Z"
      />
    </>
  ),
})

export const ChannelClosedIcon = makeIcon({
  displayName: 'ChannelClosedIcon',
  viewBox: 14,
  content: (
    <>
      <path d="M9.625 4.15625L7 4.15625C6.51675 4.15625 6.125 4.548 6.125 5.03125C6.125 5.5145 6.51675 5.90625 7 5.90625L9.625 5.90625C10.1083 5.90625 10.5 5.5145 10.5 5.03125C10.5 4.548 10.1082 4.15625 9.625 4.15625Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9375 0H3.0625C1.61275 0 0.4375 1.17525 0.4375 2.625V11.375C0.4375 12.8247 1.61275 14 3.0625 14H10.9375C12.3872 14 13.5625 12.8247 13.5625 11.375V2.625C13.5625 1.17525 12.3872 0 10.9375 0ZM4.8125 12.25H10.9375C11.4207 12.25 11.8125 11.8583 11.8125 11.375V2.625C11.8125 2.14175 11.4208 1.75 10.9375 1.75H4.8125L4.8125 12.25ZM3.0625 1.75V12.25C2.57925 12.25 2.1875 11.8582 2.1875 11.375V2.625C2.1875 2.14175 2.57925 1.75 3.0625 1.75Z"
      />
    </>
  ),
})

export const ChannelOpenIcon = makeIcon({
  displayName: 'ChannelOpenIcon',
  viewBox: 16,
  content: (
    <>
      <path d="M6.84102 6.20498C7.32241 6.1087 7.6346 5.64041 7.53832 5.15903C7.44204 4.67764 6.97375 4.36545 6.49237 4.46172L4.27015 4.90617C3.78876 5.00245 3.47657 5.47073 3.57284 5.95212C3.66912 6.43351 4.13741 6.7457 4.6188 6.64942L6.84102 6.20498Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.50065 1.75413L7.83398 0.230318C9.25357 -0.175279 10.6667 0.890637 10.6667 2.36704V13.6331C10.6667 15.1095 9.25357 16.1754 7.83398 15.7698L2.50065 14.246C1.54664 13.9734 0.888916 13.1014 0.888916 12.1092V3.89085C0.888916 2.89867 1.54664 2.0267 2.50065 1.75413ZM2.98904 3.4635C2.79824 3.51802 2.66669 3.69241 2.66669 3.89085V12.1092C2.66669 12.3077 2.79824 12.4821 2.98904 12.5366L8.32237 14.0604C8.60629 14.1415 8.88892 13.9283 8.88892 13.6331V2.36704C8.88892 2.07176 8.60629 1.85857 8.32237 1.93969L2.98904 3.4635Z"
      />
      <path d="M12.4445 3.55557C11.9536 3.55557 11.5556 3.1576 11.5556 2.66668C11.5556 2.17576 11.9536 1.77779 12.4445 1.77779H12.8889C14.1162 1.77779 15.1111 2.77272 15.1111 4.00002V12C15.1111 13.2273 14.1162 14.2222 12.8889 14.2222H12.4445C11.9536 14.2222 11.5556 13.8243 11.5556 13.3334C11.5556 12.8424 11.9536 12.4445 12.4445 12.4445H12.8889C13.1344 12.4445 13.3334 12.2455 13.3334 12V4.00002C13.3334 3.75456 13.1344 3.55557 12.8889 3.55557H12.4445Z" />
    </>
  ),
})

export const ChatIcon = makeIcon({
  displayName: 'ChatIcon',
  content: (
    <path d="M12.8,11.3c0-0.4,0.1-0.8,0.4-1.1C13.6,9.3,14,8.3,14,7.3C14,4.4,11.4,2,8,2S2,4.4,2,7.3 s2.6,5.3,6,5.3c0.4,0,0.9,0,1.3-0.1c0.3-0.1,0.7,0,1,0.1l2.5,0.8V11.3z M14.8,15.5c0,0.1,0,0.1,0,0.2c-0.1,0.3-0.4,0.4-0.6,0.3 l-4.4-1.5c-0.5,0.1-1.1,0.2-1.7,0.2c-4.4,0-8-3.3-8-7.3S3.6,0,8,0s8,3.3,8,7.3c0,1.4-0.5,2.8-1.2,3.9V15.5z M5,8.5c0.6,0,1-0.4,1-1 s-0.4-1-1-1s-1,0.4-1,1S4.4,8.5,5,8.5z M8,8.5c0.6,0,1-0.4,1-1s-0.4-1-1-1s-1,0.4-1,1S7.4,8.5,8,8.5z M11,8.5c0.6,0,1-0.4,1-1 s-0.4-1-1-1s-1,0.4-1,1S10.4,8.5,11,8.5z" />
  ),
})

export const CheckboxEmptyIcon = makeIcon({
  displayName: 'CheckboxEmptyIcon',
  content: (
    <g>
      <path d="M0 3C0 1.34315 1.34315 0 3 0H13C14.6569 0 16 1.34315 16 3V13C16 14.6569 14.6569 16 13 16H3C1.34315 16 0 14.6569 0 13V3ZM3 2C2.44772 2 2 2.44772 2 3V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13V3C14 2.44772 13.5523 2 13 2H3Z" />
    </g>
  ),
})

export const CheckboxIcon = makeIcon({
  displayName: 'CheckboxIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 3a1 1 0 011-1h7.692a1 1 0 100-2H3a3 3 0 00-3 3v10a3 3 0 003 3h10a3 3 0 003-3V9.615a1 1 0 10-2 0V13a1 1 0 01-1 1H3a1 1 0 01-1-1V3zm3.207 4.263a1 1 0 00-1.414 1.415l2.97 2.97a1 1 0 001.415 0l7.47-7.47a1 1 0 00-1.414-1.415L7.471 9.527 5.207 7.263z"
      />
    </g>
  ),
})

export const CheckMarkIcon = makeIcon({
  displayName: 'CheckMarkIcon',
  content: (
    <path d="M2.67688 7.73688C2.27774 7.36946 1.64852 7.38691 1.27148 7.77585C0.894428 8.1648 0.912336 8.77795 1.31147 9.14537L5.21148 12.7355C5.62186 13.1132 6.27232 13.0826 6.6434 12.668L14.755 3.6056C15.1159 3.20239 15.0731 2.59041 14.6593 2.23871C14.2455 1.88702 13.6175 1.92878 13.2566 2.332L5.82492 10.6347L2.67688 7.73688Z" />
  ),
})

export const ChevronIcon = makeIcon({
  displayName: 'ChevronIcon',
  content: (
    <path d="M12.2916 9.25606L6.16191 15.4913C5.83964 15.8222 5.39737 16.0088 4.9355 16.0088C4.47363 16.0088 4.03135 15.8222 3.70909 15.4913C3.03225 14.7982 3.03225 13.6916 3.70909 12.9985L8.61312 8.00965L3.70909 3.02081C3.03187 2.32661 3.03187 1.21899 3.70909 0.524793C4.38589 -0.163213 5.4851 -0.163213 6.16191 0.524793L12.2916 6.76164C12.9686 7.4553 12.9686 8.5624 12.2916 9.25606Z" />
  ),
})

export const ChevronIconNew = makeIcon({
  displayName: 'ChevronIconNew',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.29501 2.29537C5.68836 1.90154 6.3261 1.90154 6.71945 2.29537L11.705 7.28692C12.0983 7.68074 12.0983 8.31926 11.705 8.71308L6.71945 13.7046C6.3261 14.0985 5.68836 14.0985 5.29501 13.7046C4.90166 13.3108 4.90166 12.6723 5.29501 12.2785L9.56833 8L5.29501 3.72152C4.90166 3.3277 4.90166 2.68919 5.29501 2.29537Z"
    />
  ),
})

export const CircleEmptyIcon = makeIcon({
  displayName: 'CircleEmptyIcon',
  content: (
    <path d="M8,11 C9.65685,11 11,9.65685 11,8 C11,6.34315 9.65685,5 8,5 C6.34315,5 5,6.34315 5,8 C5,9.65685 6.34315,11 8,11 Z M14,8 C14,11.3137 11.3137,14 8,14 C4.68629,14 2,11.3137 2,8 C2,4.68629 4.68629,2 8,2 C11.3137,2 14,4.68629 14,8 Z" />
  ),
})
//Especially used for public channel
export const CircleHalfIcon = makeIcon({
  displayName: 'CircleHalfIcon',
  content: (
    <g transform="translate(8.000000, 8.000000) rotate(90.000000) translate(-8.000000, -8.000000) translate(2.000000, 2.000000)">
      <path d="M0,0 L0,6.03836 C0.01273,6.03828 0.02547,6.03824 0.03823,6.03824 C3.30972,6.03824 5.96179,8.6903 5.96179,11.9618 C5.96179,11.9745 5.96175,11.9873 5.96167,12 L12,12 C12,11.9873 12,11.9745 12,11.9618 C12,5.35547 6.64453,0 0.03822,0 C0.02547,0 0.01273,2e-05 0,0 Z" />
    </g>
  ),
})
// END SHAPES
export const CircleIcon = makeIcon({
  displayName: 'CircleIcon',
  content: (
    <path d="M8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2Z" />
  ),
})

export const CloseIcon = makeIcon({
  displayName: 'CloseIcon',
  content: (
    <path d="M8 6.5l5.1-5.1c.4-.4 1.1-.4 1.5 0 .4.4.4 1.1 0 1.5L9.5 8l5.1 5.1c.4.4.4 1.1 0 1.5-.4.4-1.1.4-1.5 0L8 9.5l-5.1 5.2c-.4.4-1.1.4-1.5 0-.4-.4-.4-1.1 0-1.5L6.5 8 1.3 2.9c-.4-.4-.4-1.1 0-1.5s1.1-.4 1.5 0L8 6.5z" />
  ),
})

export const CloudStrikeThroughIcon = makeIcon({
  displayName: 'CloudStrikeThroughIcon',
  content: (
    <path d="M1.99 10.902c.066-.06.08-.156.057-.242-.128-.475.236-1.017.781-1.142.156-.036.281-.212.235-.365A1.3 1.3 0 013 8.8C3 7.8 3.8 7 4.8 7c.113 0 .26.032.4.078.142.046.3-.053.3-.202V6.8C5.5 5 7 3.5 8.8 3.5c.2 0 .3 0 .5.1L10.9 2c-.6-.3-1.4-.5-2.1-.5a5.29 5.29 0 00-4.965 3.498.211.211 0 01-.139.131C2.272 5.55 1.228 6.7 1.01 8.133a.212.212 0 01-.057.115C.379 8.843 0 9.624 0 10.5c0 .6.2 1.2.6 1.7l1.39-1.298zM13.977 6.043a.206.206 0 01-.098-.129L13.6 4.8l2.1-2.1c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-1.8 1.8-1.4 1.4-7 7-1.9 1.9c-.3.4-.3 1 0 1.3.4.4 1 .4 1.4 0l1.2-1.2H12c2.2 0 4-1.8 4-4 0-1.47-.768-2.748-2.023-3.457zM12 11.5H6.9L12 6.4c.038.279.03.559-.028.832a.242.242 0 00.205.285C13.178 7.641 14 8.432 14 9.5c0 1.1-.9 2-2 2z" />
  ),
})

export const CodeIcon = makeIcon({
  displayName: 'CodeIcon',
  content: (
    <g>
      <path d="M4.06532 7.36232C3.76603 7.72119 3.47783 7.93375 3.20071 8C3.46675 8.05521 3.75218 8.26225 4.05701 8.62112C4.36184 8.97999 4.51425 9.49068 4.51425 10.1532V12.6211C4.51425 13.5597 4.99643 14.029 5.96081 14.029H6.01449C6.55877 14.029 7 14.4702 7 15.0145C7 15.5588 6.55877 16 6.01449 16H5.96081C3.4889 16 2.25297 14.8295 2.25297 12.4886V10.6998C2.25297 9.60662 1.84838 9.06004 1.03919 9.06004C0.465262 9.06004 0 8.59478 0 8.02085V7.96259C0 7.38866 0.465262 6.9234 1.03919 6.9234C1.84838 6.9234 2.25297 6.37682 2.25297 5.28364V3.51139C2.25297 1.17045 3.4889 0 5.96081 0H6.01449C6.55877 0 7 0.441227 7 0.985507C7 1.52979 6.55877 1.97101 6.01449 1.97101H5.96081C4.99643 1.97101 4.51425 2.4403 4.51425 3.37888V5.83023C4.51425 6.49276 4.36461 7.00345 4.06532 7.36232ZM11.9347 7.36232C12.234 7.72119 12.5222 7.93375 12.7993 8C12.5333 8.05521 12.2478 8.26225 11.943 8.62112C11.6382 8.97999 11.4857 9.49068 11.4857 10.1532V12.6211C11.4857 13.5597 11.0036 14.029 10.0392 14.029H9.98551C9.44123 14.029 9 14.4702 9 15.0145C9 15.5588 9.44123 16 9.98551 16H10.0392C12.5111 16 13.747 14.8295 13.747 12.4886V10.6998C13.747 9.60662 14.1516 9.06004 14.9608 9.06004C15.5347 9.06004 16 8.59478 16 8.02085V7.96259C16 7.38866 15.5347 6.9234 14.9608 6.9234C14.1516 6.9234 13.747 6.37682 13.747 5.28364V3.51139C13.747 1.17045 12.5111 0 10.0392 0H9.98551C9.44123 0 9 0.441227 9 0.985507C9 1.52979 9.44123 1.97101 9.98551 1.97101H10.0392C11.0036 1.97101 11.4857 2.4403 11.4857 3.37888V5.83023C11.4857 6.49276 11.6354 7.00345 11.9347 7.36232Z" />
    </g>
  ),
})

export const CogIcon = makeIcon({
  displayName: 'CogIcon',
  content: (
    <g>
      <path d="M5.3,2.7c0.3-0.1,0.6-0.3,0.9-0.4l0.2-1C6.5,0.5,7.2,0,8,0s1.5,0.5,1.6,1.3l0.2,1 c0.3,0.1,0.6,0.2,0.9,0.4l0.9-0.5c0.7-0.4,1.5-0.3,2.1,0.2c0.6,0.6,0.6,1.4,0.2,2.1l-0.5,0.9c0.1,0.3,0.3,0.6,0.4,0.9l1,0.2 C15.5,6.5,16,7.2,16,8s-0.5,1.5-1.3,1.6l-1,0.2c-0.1,0.3-0.2,0.6-0.4,0.9l0.5,0.9c0.4,0.7,0.3,1.5-0.2,2.1c-0.6,0.6-1.4,0.6-2.1,0.2 l-0.9-0.5c-0.3,0.1-0.6,0.3-0.9,0.4l-0.2,1C9.5,15.5,8.8,16,8,16s-1.5-0.5-1.6-1.3l-0.2-1c-0.3-0.1-0.6-0.2-0.9-0.4l-0.9,0.5 c-0.7,0.4-1.5,0.3-2.1-0.2c-0.6-0.6-0.6-1.4-0.2-2.1l0.5-0.9C2.5,10.3,2.3,10,2.2,9.7l-1-0.2C0.5,9.5,0,8.8,0,8s0.5-1.5,1.3-1.6 l1-0.2c0.1-0.3,0.2-0.6,0.4-0.9L2.1,4.4C1.7,3.8,1.8,2.9,2.3,2.3c0.6-0.6,1.4-0.6,2.1-0.2L5.3,2.7z M8,12c2.2,0,4-1.8,4-4 s-1.8-4-4-4S4,5.8,4,8S5.8,12,8,12z" />
    </g>
  ),
})

export const CommentsEmptyIcon = makeIcon({
  displayName: 'CommentsEmpty',
  content: (
    <g>
      <path d="M14.7426 15.6573C14.7594 15.6066 14.768 15.5534 14.768 15.4999V11.2524C15.5483 10.1196 16 8.77722 16 7.3381C16 3.28538 12.4183 0 8 0C3.58173 0 0 3.28538 0 7.3381C0 11.3908 3.58173 14.6762 8 14.6762C8.58234 14.6762 9.15021 14.6191 9.6972 14.5107L14.1106 15.9745C14.3727 16.0614 14.6556 15.9194 14.7426 15.6573ZM13.121 10.1179C12.8911 10.4516 12.768 10.8472 12.768 11.2524V13.4221L10.3268 12.6124C9.99854 12.5036 9.64771 12.4817 9.30847 12.5489C8.88293 12.6332 8.44519 12.6762 8 12.6762C4.6496 12.6762 2 10.2458 2 7.3381C2 4.43036 4.6496 2 8 2C11.3504 2 14 4.43036 14 7.3381C14 8.33215 13.6949 9.28461 13.121 10.1179Z" />
    </g>
  ),
})

export const CommentsIcon = makeIcon({
  displayName: 'CommentsIcon',
  content: (
    <path d="M14.768 15.4999C14.768 15.5534 14.7594 15.6066 14.7426 15.6573C14.6556 15.9194 14.3727 16.0614 14.1106 15.9745L9.69718 14.5107C9.15018 14.6191 8.58236 14.6762 8 14.6762C3.58172 14.6762 0 11.3908 0 7.3381C0 3.28538 3.58172 0 8 0C12.4183 0 16 3.28538 16 7.3381C16 8.77722 15.5484 10.1196 14.768 11.2524V15.4999Z" />
  ),
})

export const CreateNoteIcon = makeIcon({
  displayName: 'CreateNoteIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 1C7 0.447715 6.55228 0 6 0C5.44772 0 5 0.447715 5 1V5H1C0.447715 5 0 5.44772 0 6C0 6.55228 0.447715 7 1 7H5V11C5 11.5523 5.44771 12 6 12C6.55228 12 7 11.5523 7 11V7H11C11.5523 7 12 6.55228 12 6C12 5.44772 11.5523 5 11 5H7V1Z"
    />
  ),
})

export const DeleteIcon = makeIcon({
  displayName: 'DeleteIcon',
  content: (
    <path d="M13.7,6l-1.5,9.2c-0.1,0.5-0.5,0.8-1,0.8H4.8c-0.5,0-0.9-0.4-1-0.8L2.3,6H1C0.4,6,0,5.6,0,5 s0.4-1,1-1h14c0.6,0,1,0.4,1,1s-0.4,1-1,1H13.7z M5,0h6c0.6,0,1,0.4,1,1s-0.4,1-1,1H5C4.4,2,4,1.6,4,1S4.4,0,5,0z M4.4,6l1.3,8h4.6 l1.3-8H4.4z" />
  ),
})

export const DiscountIcon = makeIcon({
  displayName: 'DiscountIcon',
  content: (
    <g>
      <path
        fill="#5168EC"
        d="M7 15c-.5.3-1.2.2-1.5-.3l-.1-.1c-.3-.7-1-1.1-1.8-1-.6 0-1.1-.4-1.2-1v-.2c.1-.8-.4-1.5-1-1.8-.5-.3-.8-.9-.5-1.4 0 0 0-.1.1-.1.4-.7.4-1.5 0-2.1-.4-.5-.2-1.2.3-1.5l.1-.1c.7-.3 1.1-1 1-1.8 0-.6.4-1.1 1-1.2h.2c.8.1 1.5-.4 1.8-1 .3-.5.9-.8 1.4-.5 0 0 .1 0 .1.1.7.4 1.5.4 2.1 0 .5-.3 1.2-.2 1.5.3l.1.1c.3.7 1 1.1 1.8 1 .6 0 1.1.4 1.2 1v.2c-.1.8.4 1.5 1 1.8.5.3.8.9.5 1.4 0 0 0 .1-.1.1-.4.6-.4 1.4 0 2.1.3.5.2 1.2-.3 1.5l-.1.1c-.7.3-1.1 1-1 1.8 0 .6-.4 1.1-1 1.2h-.2c-.8-.1-1.5.4-1.8 1-.3.5-.9.8-1.4.5 0 0-.1 0-.1-.1-.7-.4-1.5-.4-2.1 0z"
      />
      <path
        fill="#ffffff"
        d="M10.8 4.7c-.1-.1-.2-.1-.4-.1-.1 0-.3.1-.3.2l-4.3 5.5c-.2.2-.1.5.1.7v.1c.1.1.2.1.3.1.1 0 .3-.1.4-.2L11 5.4c0-.2 0-.5-.2-.7zM11 9c-.3-.3-.6-.4-1-.4s-.7.1-1 .4c-.3.3-.4.6-.4 1s.1.7.4 1c.3.3.6.4 1 .4s.7-.1 1-.4c.3-.3.4-.6.4-1s-.1-.7-.4-1zm-.6 1c0 .1 0 .2-.1.3-.1.1-.2.1-.3.1-.1 0-.2 0-.3-.1-.1-.1-.1-.2-.1-.3 0-.1 0-.2.1-.3.1-.1.2-.1.3-.1s.2 0 .3.1c.1.1.1.2.1.3zM7.3 7c.3-.3.4-.6.4-1s-.2-.8-.4-1c-.3-.3-.6-.4-1-.4s-.7.1-1 .4c-.3.2-.4.6-.4 1s.1.7.4 1c.3.3.6.4 1 .4s.7-.2 1-.4zm-.6-1c0 .1 0 .2-.1.3-.1 0-.2.1-.3.1-.1 0-.2 0-.3-.1-.1-.1-.1-.2-.1-.3s0-.2.1-.3c.1-.1.2-.1.3-.1s.2 0 .3.1c0 .1.1.2.1.3z"
      />
    </g>
  ),
})

export const DlIcon = makeIcon({
  displayName: 'DlIcon',
  content: (
    <g>
      <path d="M16 15C16 14.4477 15.5523 14 15 14L1 14C0.447715 14 -6.78526e-08 14.4477 -4.37114e-08 15C-1.95703e-08 15.5523 0.447715 16 1 16L15 16C15.5523 16 16 15.5523 16 15ZM4.46446 7.46288C4.85499 7.07236 5.48815 7.07236 5.87868 7.46288L6.99578 8.57998L6.99578 1C6.99578 0.447719 7.4435 3.48933e-06 7.99578 3.46519e-06C8.54806 3.44105e-06 8.99578 0.447718 8.99578 1L8.99578 8.58842L10.1213 7.46288C10.5118 7.07235 11.145 7.07235 11.5355 7.46288C11.9261 7.8534 11.9261 8.48657 11.5355 8.87709L8.7071 11.7055C8.60385 11.8088 8.48363 11.8847 8.35542 11.9334C8.24382 11.9764 8.12255 12 7.99578 12C7.68694 12 7.41081 11.86 7.22737 11.64L4.46446 8.87709C4.07394 8.48657 4.07394 7.8534 4.46446 7.46288Z" />
    </g>
  ),
})

export const DuplicateIcon = makeIcon({
  displayName: 'DuplicateIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.69527 10.2325C3.30087 10.5501 3.90973 10.0098 3.90973 9.32597C3.90973 8.89214 3.65586 8.50718 3.31678 8.23656C2.49895 7.58384 2 6.58684 2 5.5C2 3.567 3.567 2 5.5 2C6.6066 2 7.61979 2.51736 8.27128 3.36096C8.52567 3.69038 8.8948 3.93508 9.31101 3.93508C10.0219 3.93508 10.5458 3.25984 10.1864 2.64643C9.19713 0.957741 7.24791 0 5.5 0C2.46243 0 0 2.46243 0 5.5C0 7.2386 1.05459 9.37196 2.69527 10.2325ZM10.5 16C7.46243 16 5 13.5376 5 10.5C5 7.46243 7.46243 5 10.5 5C13.5376 5 16 7.46243 16 10.5C16 13.5376 13.5376 16 10.5 16ZM14 10.5C14 12.433 12.433 14 10.5 14C8.567 14 7 12.433 7 10.5C7 8.567 8.567 7 10.5 7C12.433 7 14 8.567 14 10.5Z"
    />
  ),
})

export const EmojiIcon = makeIcon({
  displayName: 'EmojiIcon',
  content: (
    <path d="M8,14c3.3,0,6-2.7,6-6s-2.7-6-6-6S2,4.7,2,8S4.7,14,8,14z M8,16c-4.4,0-8-3.6-8-8s3.6-8,8-8 s8,3.6,8,8S12.4,16,8,16z M6,5c0.6,0,1,0.4,1,1S6.6,7,6,7S5,6.6,5,6S5.4,5,6,5z M10,5c0.6,0,1,0.4,1,1s-0.4,1-1,1C9.4,7,9,6.6,9,6 S9.4,5,10,5z M5,9h6l0,0c0,1.7-1.3,3-3,3l0,0C6.3,12,5,10.7,5,9z" />
  ),
})

export const EmptyIcon = makeIcon({
  displayName: 'EmptyIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 3C1 1.34315 2.34315 0 4 0H12C13.6569 0 15 1.34315 15 3V13C15 14.6569 13.6569 16 12 16H4C2.34315 16 1 14.6569 1 13V3ZM4 2C3.44772 2 3 2.44772 3 3V13C3 13.5523 3.44772 14 4 14H12C12.5523 14 13 13.5523 13 13V3C13 2.44772 12.5523 2 12 2H4Z"
      />
    </g>
  ),
})

export const ErrorIcon = makeIcon({
  displayName: 'ErrorIcon',
  content: (
    <path d="M6.19889 1.53049C6.92657 0.0231542 9.07342 0.0231657 9.80109 1.5305L15.2079 12.7303C15.849 14.0583 14.8814 15.5998 13.4068 15.5998H2.59318C1.11853 15.5998 0.150974 14.0583 0.792077 12.7303L6.19889 1.53049ZM7.99999 2.39999L2.59318 13.5998L13.4068 13.5998L7.99999 2.39999ZM7.25 6.34982C7.25 5.93561 7.58579 5.59982 8 5.59982C8.41421 5.59982 8.75 5.93561 8.75 6.34982V9.34982C8.75 9.76404 8.41421 10.0998 8 10.0998C7.58579 10.0998 7.25 9.76404 7.25 9.34982V6.34982ZM8 11.0998C7.58579 11.0998 7.25 11.4356 7.25 11.8498C7.25 12.264 7.58579 12.5998 8 12.5998C8.41421 12.5998 8.75 12.264 8.75 11.8498C8.75 11.4356 8.41421 11.0998 8 11.0998Z" />
  ),
})

export const ExpandIcon = makeIcon({
  displayName: 'ExpandIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 1C16 0.447715 15.5523 0 15 0H12.043C11.494 0 11.049 0.445045 11.049 0.994035C11.049 1.54303 11.494 1.98807 12.043 1.98807H12.5791L10.3126 4.47436C9.94054 4.88251 9.96979 5.515 10.3779 5.88707C10.7861 6.25913 11.4186 6.22988 11.7906 5.82174L14.0044 3.39332V4.01343C14.0044 4.56451 14.4511 5.01124 15.0022 5.01124C15.5533 5.01124 16 4.56512 16 4.01404V1ZM16 12.02C16 11.4929 15.5727 11.0664 15.0457 11.0664C14.5186 11.0664 14.0913 11.4936 14.0913 12.0207V12.829L11.7906 10.3052C11.4186 9.89702 10.7861 9.86777 10.3779 10.2398C9.96979 10.6119 9.94054 11.2444 10.3126 11.6525L12.4123 13.9558H12.0659C11.5014 13.9558 11.0438 14.4134 11.0438 14.9779C11.0438 15.5424 11.5013 16 12.0658 16H15C15.5523 16 16 15.5523 16 15V12.02ZM5.09163 14.9855C5.09163 15.5458 4.63826 16 4.07798 16H1C0.447715 16 0 15.5523 0 15V12.0397C0 11.4737 0.45885 11.0149 1.02487 11.0149C1.59089 11.0149 2.04974 11.4737 2.04974 12.0398V12.6657L4.20165 10.3052C4.57371 9.89702 5.2062 9.86777 5.61435 10.2398C6.0225 10.6119 6.05175 11.2444 5.67968 11.6525L3.56611 13.9711H4.07717C4.63744 13.9711 5.09163 14.4253 5.09163 14.9855ZM0 4.02608C0 4.59201 0.463295 5.04772 1.02916 5.03921C1.58311 5.03087 2.02781 4.57943 2.02781 4.02542V3.43709L4.20165 5.82174C4.57371 6.22988 5.2062 6.25913 5.61435 5.88707C6.0225 5.515 6.05175 4.88251 5.67968 4.47436L3.42544 2.00152H4.12554C4.67824 2.00152 5.1263 1.55347 5.1263 1.00076C5.1263 0.448056 4.67824 0 4.12554 0H1C0.447715 0 0 0.447715 0 1V4.02608Z"
      />
    </g>
  ),
})

export const ExternalLinkIcon = makeIcon({
  displayName: 'ExternalLinkIcon',
  content: (
    <path d="M2 3C2 2.44772 2.44772 2 3 2H6C6.55228 2 7 1.55228 7 1C7 0.447715 6.55228 0 6 0H3C1.34315 0 0 1.34315 0 3V13C0 14.6569 1.34315 16 3 16H13C14.6569 16 16 14.6569 16 13V10C16 9.44772 15.5523 9 15 9C14.4477 9 14 9.44772 14 10V13C14 13.5523 13.5523 14 13 14H3C2.44772 14 2 13.5523 2 13V3ZM15 6C14.4477 6 14 5.55228 14 5V3.41363L8.91909 8.49455C8.51436 8.89928 7.85816 8.89928 7.45343 8.49455C7.0487 8.08982 7.0487 7.43362 7.45343 7.02889L12.4823 2L11 2C10.4477 2 10 1.55228 10 0.999999C10 0.447715 10.4477 0 11 0H15C15.5523 0 16 0.447715 16 1V5C16 5.55228 15.5523 6 15 6Z" />
  ),
})

export const EyeCrossedIcon = makeIcon({
  displayName: 'EyeCrossedIcon',
  content: (
    <g>
      <path d="M1.3747 13.2253L1.28 13.32C0.893402 13.7066 0.893401 14.3334 1.28 14.72C1.6666 15.1066 2.2934 15.1066 2.68 14.72L4.59992 12.8001C5.66547 13.3474 6.79826 13.635 8 13.635C11.0421 13.635 13.6425 11.7923 15.8285 8.55743C16.0572 8.21914 16.0572 7.77586 15.8285 7.43757C14.9768 6.17719 14.0621 5.12813 13.083 4.31707L14.715 2.68501C15.1016 2.29841 15.1016 1.67161 14.715 1.28501C14.3284 0.898406 13.7016 0.898406 13.315 1.28501L12.5232 2.07686C12.4749 2.19144 12.4041 2.29878 12.3108 2.39211L1.68995 13.0129C1.59661 13.1063 1.48928 13.1771 1.3747 13.2253ZM9.40703 2.49584C8.94895 2.40587 8.47997 2.36 8 2.36C4.95786 2.36 2.35755 4.20274 0.171458 7.43757C-0.0571525 7.77586 -0.0571525 8.21914 0.171458 8.55743C0.614808 9.21347 1.0752 9.81225 1.55285 10.35L2.96909 8.93378C2.71923 8.64668 2.47042 8.33487 2.22271 7.9975C3.94167 5.65637 5.71366 4.54615 7.52122 4.38165L9.40703 2.49584ZM8 11.635C7.36685 11.635 6.73784 11.5228 6.11373 11.2863L7.07624 10.3238C7.36201 10.4375 7.67371 10.5 8 10.5C9.38071 10.5 10.5 9.38071 10.5 8C10.5 7.67371 10.4375 7.36201 10.3238 7.07624L11.6618 5.73821C12.3749 6.30169 13.0805 7.04846 13.7773 7.9975C11.9068 10.545 9.97356 11.635 8 11.635Z" />
    </g>
  ),
})

export const EyeIcon = makeIcon({
  displayName: 'EyeIcon',
  content: (
    <g>
      <path d="M8 11.635C6.02644 11.635 4.09318 10.545 2.22271 7.9975C4.09318 5.45002 6.02644 4.36 8 4.36C9.97356 4.36 11.9068 5.45002 13.7773 7.9975C11.9068 10.545 9.97356 11.635 8 11.635ZM8 2.36C4.95786 2.36 2.35755 4.20274 0.171458 7.43757C-0.0571525 7.77586 -0.0571525 8.21914 0.171458 8.55743C2.35755 11.7923 4.95786 13.635 8 13.635C11.0421 13.635 13.6425 11.7923 15.8285 8.55743C16.0572 8.21914 16.0572 7.77586 15.8285 7.43757C13.6425 4.20274 11.0421 2.36 8 2.36ZM10.5 8C10.5 9.38071 9.38071 10.5 8 10.5C6.61929 10.5 5.5 9.38071 5.5 8C5.5 6.61929 6.61929 5.5 8 5.5C9.38071 5.5 10.5 6.61929 10.5 8Z" />
    </g>
  ),
})

export const FavoriteEmptyIcon = makeIcon({
  displayName: 'FavoriteIcon',
  content: (
    <path d="M5.4,12.7l1.8-0.8c0.5-0.2,1.1-0.2,1.7,0l1.8,0.8l-0.2-2.2c-0.1-0.5,0.1-1.1,0.5-1.5l1.5-1.7 l-2.1-0.5c-0.6-0.1-1-0.5-1.3-1L8,4.1L7,5.9c-0.3,0.5-0.7,0.9-1.3,1L3.6,7.3l1.5,1.7c0.3,0.4,0.5,0.9,0.5,1.5L5.4,12.7z M8,13.7 l-4.2,1.9c-0.3,0.1-0.5,0-0.7-0.2c0-0.1-0.1-0.2,0-0.3l0.5-4.8L0.5,6.7C0.4,6.5,0.4,6.2,0.6,6C0.7,6,0.7,5.9,0.8,5.9l4.5-1l2.3-4.1 C7.7,0.5,8,0.5,8.2,0.6c0.1,0,0.1,0.1,0.2,0.2l2.3,4.1l4.5,1c0.3,0.1,0.4,0.3,0.4,0.6c0,0.1-0.1,0.2-0.1,0.2l-3.1,3.6l0.5,4.8 c0,0.3-0.2,0.5-0.5,0.5c-0.1,0-0.2,0-0.3,0L8,13.7z" />
  ),
})

export const FavoriteIcon = makeIcon({
  displayName: 'FavoriteIcon',
  content: (
    <path d="M8,13.7l-4.2,1.9c-0.3,0.1-0.5,0-0.7-0.2c0-0.1-0.1-0.2,0-0.3l0.5-4.8L0.5,6.7C0.4,6.5,0.4,6.2,0.6,6 C0.7,6,0.7,5.9,0.8,5.9l4.5-1l2.3-4.1C7.7,0.5,8,0.5,8.2,0.6c0.1,0,0.1,0.1,0.2,0.2l2.3,4.1l4.5,1c0.3,0.1,0.4,0.3,0.4,0.6 c0,0.1-0.1,0.2-0.1,0.2l-3.1,3.6l0.5,4.8c0,0.3-0.2,0.5-0.5,0.5c-0.1,0-0.2,0-0.3,0L8,13.7z" />
  ),
})

export const FileMDIcon = makeIcon({
  displayName: 'FileMDIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 3C1 1.34315 2.34315 0 4 0H11C12.6569 0 14 1.34315 14 3V6H14.5C15.3284 6 16 6.67157 16 7.5V10.5C16 11.3284 15.3284 12 14.5 12H14V13C14 14.6569 12.6569 16 11 16H4C2.34315 16 1 14.6569 1 13V3ZM12 3V6H6.5C5.67157 6 5 6.67157 5 7.5V10.5C5 11.3284 5.67157 12 6.5 12H12V13C12 13.5523 11.5523 14 11 14H4C3.44772 14 3 13.5523 3 13V3C3 2.44772 3.44772 2 4 2H11C11.5523 2 12 2.44772 12 3ZM8.55 7.35H7.66V10.6H8.45V9.64C8.45 9.55667 8.44583 9.465 8.4375 9.365C8.42917 9.265 8.42 9.1625 8.41 9.0575C8.4 8.9525 8.38833 8.85 8.375 8.75C8.36167 8.65 8.35 8.56 8.34 8.48H8.36L8.62 9.24L9.07 10.335H9.39L9.84 9.24L10.11 8.48H10.13C10.12 8.56 10.1083 8.65 10.095 8.75C10.0817 8.85 10.07 8.9525 10.06 9.0575C10.05 9.1625 10.0408 9.265 10.0325 9.365C10.0242 9.465 10.02 9.55667 10.02 9.64V10.6H10.82V7.35H9.93L9.44 8.7L9.26 9.23H9.24L9.06 8.7L8.55 7.35ZM11.54 7.35H12.5C12.7467 7.35 12.9725 7.38 13.1775 7.44C13.3825 7.5 13.5583 7.595 13.705 7.725C13.8517 7.855 13.9658 8.02167 14.0475 8.225C14.1292 8.42833 14.17 8.67333 14.17 8.96C14.17 9.24667 14.13 9.49333 14.05 9.7C13.97 9.90667 13.8575 10.0767 13.7125 10.21C13.5675 10.3433 13.3958 10.4417 13.1975 10.505C12.9992 10.5683 12.7833 10.6 12.55 10.6H11.54V7.35ZM12.78 9.8675C12.6767 9.89583 12.5667 9.91 12.45 9.91H12.4V8.04H12.45C12.5667 8.04 12.6767 8.0525 12.78 8.0775C12.8833 8.1025 12.9725 8.14833 13.0475 8.215C13.1225 8.28167 13.1817 8.375 13.225 8.495C13.2683 8.615 13.29 8.77 13.29 8.96C13.29 9.15 13.2683 9.30667 13.225 9.43C13.1817 9.55333 13.1225 9.65 13.0475 9.72C12.9725 9.79 12.8833 9.83917 12.78 9.8675Z"
      />
    </g>
  ),
})

export const FilePDFIcon = makeIcon({
  displayName: 'FilePDFIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 3C1 1.34315 2.34315 0 4 0H11C12.6569 0 14 1.34315 14 3V6H14.5C15.3284 6 16 6.67157 16 7.5V10.5C16 11.3284 15.3284 12 14.5 12H14V13C14 14.6569 12.6569 16 11 16H4C2.34315 16 1 14.6569 1 13V3ZM12 3V6H6.5C5.67157 6 5 6.67157 5 7.5V10.5C5 11.3284 5.67157 12 6.5 12H12V13C12 13.5523 11.5523 14 11 14H4C3.44772 14 3 13.5523 3 13V3C3 2.44772 3.44772 2 4 2H11C11.5523 2 12 2.44772 12 3ZM10.7878 7.45H9.82776V10.7H10.8378C11.0711 10.7 11.2869 10.6683 11.4853 10.605C11.6836 10.5417 11.8553 10.4433 12.0003 10.31C12.1453 10.1767 12.2578 10.0067 12.3378 9.8C12.4178 9.59333 12.4578 9.34667 12.4578 9.06C12.4578 8.77333 12.4169 8.52833 12.3353 8.325C12.2536 8.12166 12.1394 7.955 11.9928 7.825C11.8461 7.695 11.6703 7.6 11.4653 7.54C11.2603 7.48 11.0344 7.45 10.7878 7.45ZM12.8156 7.45H14.9356V8.17H13.6756V8.79H14.7556V9.51H13.6756V10.7H12.8156V7.45ZM8.22 7.45H6.96V10.7H7.82V9.67H8.22C8.39 9.67 8.55333 9.6475 8.71 9.6025C8.86667 9.5575 9.005 9.48917 9.125 9.3975C9.245 9.30583 9.34083 9.18833 9.4125 9.045C9.48417 8.90167 9.52 8.73 9.52 8.53C9.52 8.32667 9.485 8.15583 9.415 8.0175C9.345 7.87917 9.25083 7.7675 9.1325 7.6825C9.01417 7.5975 8.87583 7.5375 8.7175 7.5025C8.55917 7.4675 8.39333 7.45 8.22 7.45ZM8.18001 8.99C8.35001 8.99 8.47584 8.95001 8.55751 8.87C8.63917 8.79 8.68001 8.67667 8.68001 8.53C8.68001 8.38334 8.63667 8.28001 8.55001 8.22001C8.46334 8.16 8.34001 8.13 8.18001 8.13H7.82001V8.99H8.18001ZM11.0678 9.9675C10.9645 9.99583 10.8545 10.01 10.7378 10.01H10.6878V8.14H10.7378C10.8545 8.14 10.9645 8.1525 11.0678 8.1775C11.1711 8.2025 11.2603 8.24833 11.3353 8.315C11.4103 8.38167 11.4695 8.475 11.5128 8.595C11.5561 8.715 11.5778 8.87 11.5778 9.06C11.5778 9.25 11.5561 9.40667 11.5128 9.53C11.4695 9.65333 11.4103 9.75 11.3353 9.82C11.2603 9.89 11.1711 9.93917 11.0678 9.9675Z"
      />
    </g>
  ),
})

export const ForbiddenIcon = makeIcon({
  displayName: 'ForbiddenIcon',
  content: (
    <path d="M4.5 12.9c1 .7 2.2 1.1 3.5 1.1 3.3 0 6-2.7 6-6 0-1.3-.4-2.5-1.1-3.5l-8.4 8.4zm-1.4-1.4l8.4-8.4C10.5 2.4 9.3 2 8 2 4.7 2 2 4.7 2 8c0 1.3.4 2.5 1.1 3.5zM8 16c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z" />
  ),
})

export const GoogleIcon = makeIcon({
  displayName: 'GoogleIcon',
  viewBox: 18,
  content: (
    <g id="Google-Button" stroke="none" fill="none">
      <g
        id="btn_google_dark_normal"
        transform="translate(-15.000000, -15.000000)"
      >
        <g id="logo_googleg_48dp" transform="translate(15.000000, 15.000000)">
          <path
            d="M17.64,9.20454545 C17.64,8.56636364 17.5827273,7.95272727 17.4763636,7.36363636 L9,7.36363636 L9,10.845 L13.8436364,10.845 C13.635,11.97 13.0009091,12.9231818 12.0477273,13.5613636 L12.0477273,15.8195455 L14.9563636,15.8195455 C16.6581818,14.2527273 17.64,11.9454545 17.64,9.20454545 L17.64,9.20454545 Z"
            id="Shape"
            fill="#4285F4"
          />
          <path
            d="M9,18 C11.43,18 13.4672727,17.1940909 14.9563636,15.8195455 L12.0477273,13.5613636 C11.2418182,14.1013636 10.2109091,14.4204545 9,14.4204545 C6.65590909,14.4204545 4.67181818,12.8372727 3.96409091,10.71 L0.957272727,10.71 L0.957272727,13.0418182 C2.43818182,15.9831818 5.48181818,18 9,18 L9,18 Z"
            id="Shape"
            fill="#34A853"
          />
          <path
            d="M3.96409091,10.71 C3.78409091,10.17 3.68181818,9.59318182 3.68181818,9 C3.68181818,8.40681818 3.78409091,7.83 3.96409091,7.29 L3.96409091,4.95818182 L0.957272727,4.95818182 C0.347727273,6.17318182 0,7.54772727 0,9 C0,10.4522727 0.347727273,11.8268182 0.957272727,13.0418182 L3.96409091,10.71 L3.96409091,10.71 Z"
            id="Shape"
            fill="#FBBC05"
          />
          <path
            d="M9,3.57954545 C10.3213636,3.57954545 11.5077273,4.03363636 12.4404545,4.92545455 L15.0218182,2.34409091 C13.4631818,0.891818182 11.4259091,0 9,0 C5.48181818,0 2.43818182,2.01681818 0.957272727,4.95818182 L3.96409091,7.29 C4.67181818,5.16272727 6.65590909,3.57954545 9,3.57954545 L9,3.57954545 Z"
            id="Shape"
            fill="#EA4335"
          />
          <polygon id="Shape" points="0 0 18 0 18 18 0 18" />
        </g>
      </g>
    </g>
  ),
})

export const GooglePlayIcon = makeIcon({
  displayName: 'GooglePlayIcon',
  viewBoxHeight: 24,
  viewBoxWidth: 21,
  content: (
    <path d="M1.101 0l11.22 11.225 3.077-3.1L1.798.212A1.48 1.48 0 0 0 1.1 0zm-.94.522A1.295 1.295 0 0 0 0 1.158v21.814c0 .175.036.333.097.473l11.48-11.486L.162.522zm16.176 8.141L13.05 11.96l3.287 3.28 4.015-2.317c.571-.333.652-.755.648-.98-.006-.37-.239-.717-.632-.93-.342-.185-2.882-1.675-4.031-2.349zm-4.016 4.03L1.004 24c.188-.01.392-.051.583-.163.443-.26 9.407-5.482 9.407-5.482l4.42-2.562-3.093-3.1z" />
  ),
})

export const HeaderOneIcon = makeIcon({
  displayName: 'HeaderOneIcon',
  content: (
    <g>
      <path d="M0 0.75C0 0.335786 0.335786 0 0.75 0H1H7H9H15H15.25C15.6642 0 16 0.335786 16 0.75V1V2V3.5C16 4.05228 15.5523 4.5 15 4.5C14.4477 4.5 14 4.05228 14 3.5V2H9V14H11C11.5523 14 12 14.4477 12 15C12 15.5523 11.5523 16 11 16H9H7H5C4.44772 16 4 15.5523 4 15C4 14.4477 4.44772 14 5 14H7V2H2V3.5C2 4.05228 1.55228 4.5 1 4.5C0.447715 4.5 0 4.05228 0 3.5V2V1V0.75Z" />
    </g>
  ),
})

export const HeaderTwoIcon = makeIcon({
  displayName: 'HeaderTwoIcon',
  content: (
    <g>
      <path d="M2 2.75C2 2.33579 2.33579 2 2.75 2H3H7H9H13H13.25C13.6642 2 14 2.33579 14 2.75V3V4V5C14 5.55228 13.5523 6 13 6C12.4477 6 12 5.55228 12 5V4H9V12H10.5C11.0523 12 11.5 12.4477 11.5 13C11.5 13.5523 11.0523 14 10.5 14H9H7H5.5C4.94772 14 4.5 13.5523 4.5 13C4.5 12.4477 4.94772 12 5.5 12H7V4H4V5C4 5.55228 3.55228 6 3 6C2.44772 6 2 5.55228 2 5V4V3V2.75Z" />
    </g>
  ),
})

export const HelpIcon = makeIcon({
  displayName: 'HelpIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8ZM14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.032 11.4462C9.43648 11.7981 8.74183 12 8.00003 12C7.25822 12 6.56358 11.7981 5.96807 11.4462L3.70715 13.7071L2.29294 12.2929L4.55385 10.032C4.20196 9.43646 4.00003 8.74181 4.00003 8C4.00003 7.2582 4.20196 6.56355 4.55384 5.96804L2.29291 3.70711L3.70712 2.29289L5.96805 4.55382C6.56357 4.20193 7.25822 4 8.00003 4C8.74184 4 9.43649 4.20193 10.032 4.55382L12.2929 2.29289L13.7071 3.70711L11.4462 5.96804C11.7981 6.56355 12 7.2582 12 8C12 8.74181 11.7981 9.43646 11.4462 10.032L13.7071 12.2929L12.2929 13.7071L10.032 11.4462ZM8.00003 10C9.1046 10 10 9.10457 10 8C10 6.89543 9.1046 6 8.00003 6C6.89546 6 6.00003 6.89543 6.00003 8C6.00003 9.10457 6.89546 10 8.00003 10Z"
      />
    </g>
  ),
})

export const HighlightIcon = makeIcon({
  displayName: 'Highlight',
  content: (
    <g strokeWidth="1">
      <path
        d="M0,15 C-1.0000003e-08,14.4477 0.447715045,14 0.999998209,14 L5.9999997,14 C6.55228987,14 7,14.4477 7,15 C7,15.5523 6.55228987,16 5.9999997,16 L0.999998209,16 C0.447715045,16 1.0000003e-08,15.5523 0,15 Z"
        id="Path"
        opacity="0.6"
      />
      <path
        d="M9.4258872,0.779220035 L6.09008525,9.17671185 L13.6448121,11.7432725 L15.9578277,2.99829945 C16.1258866,2.36276208 15.7776105,1.70419735 15.1630289,1.49538803 L10.9514578,0.06457625 C10.3367781,-0.144232077 9.66831751,0.168920182 9.4258872,0.779220035 Z M12.2913204,9.18378035 L8.68804599,7.95965635 L10.9855794,2.17581532 L13.8843499,3.16062595 L12.2913204,9.18378035 Z M5.30541503,12.2132777 C5.24742786,12.0952039 5.23801499,11.9585132 5.27926492,11.8332714 L5.83708506,10.1405161 L13.2756512,12.6676525 L12.7178409,14.3604078 C12.6766596,14.48555 12.5880218,14.588989 12.4716356,14.6479263 L11.4123941,15.1841364 L11.1618746,15.8409091 C11.1253017,15.9367818 11.0345067,16 10.9333184,16 L5.24532957,15.9999004 C5.07651571,15.9999004 4.95822736,15.8307543 5.01392996,15.6689754 L5.83333953,13.2886845 L5.30541503,12.2132777 Z"
        id="Shape"
      />
    </g>
  ),
})

export const HomeIcon = makeIcon({
  displayName: 'HomeIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7188 8.30563C15.074 8.40794 15.4725 8.30912 15.7379 8.01761C16.1097 7.60926 16.0794 6.97743 15.6702 6.60638L8.67219 0.259656C8.29045 -0.0865519 7.70762 -0.0865519 7.32588 0.259656L0.327819 6.60638C-0.0813174 6.97743 -0.111607 7.60926 0.260163 8.01761C0.509613 8.2916 0.876691 8.39537 1.21483 8.3219V15.0003C1.21483 15.5526 1.66255 16.0003 2.21483 16.0003H6.04948C6.60176 16.0003 7.04948 15.5526 7.04948 15.0003V12.6122C7.04948 12.0174 7.53171 11.5351 8.12658 11.5351C8.72144 11.5351 9.20367 12.0174 9.20367 12.6122V15.0003C9.20367 15.5526 9.65139 16.0003 10.2037 16.0003H13.7188C14.271 16.0003 14.7188 15.5526 14.7188 15.0003V8.30563ZM12.7188 6.62936L7.99903 2.34891L3.21483 6.68783V14.0003H5.04948V12.6122C5.04948 10.9128 6.42714 9.53514 8.12658 9.53514C9.82601 9.53514 11.2037 10.9128 11.2037 12.6122V14.0003H12.7188V6.62936Z"
      />
    </g>
  ),
})

export const HorizontalArrowsIcon = makeIcon({
  displayName: 'HorizontalArrowsIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.2 1.264a.9.9 0 0 1 1.274 1.274l-1.29 1.289h7.757a1 1 0 1 1 0 2h-7.84L4.474 7.2A.9.9 0 0 1 3.2 8.474L.264 5.538a.898.898 0 0 1-.263-.66.898.898 0 0 1 .263-.678L3.2 1.264zm8.267 6a.9.9 0 0 1 1.274 0l2.936 2.936a.898.898 0 0 1 .263.678.898.898 0 0 1-.263.66l-2.936 2.936a.9.9 0 1 1-1.274-1.274l1.373-1.373H5a1 1 0 1 1 0-2h7.756l-1.29-1.29a.9.9 0 0 1 0-1.273z"
    />
  ),
})

export const IndentedListIcon = makeIcon({
  displayName: 'IndentedList',
  content: (
    <g>
      <path d="M0 4C0 3.44772 0.447715 3 1 3H7C7.55228 3 8 3.44772 8 4C8 4.55228 7.55228 5 7 5H1C0.447715 5 0 4.55228 0 4ZM4 8C4 7.44772 4.44772 7 5 7H11C11.5523 7 12 7.44772 12 8C12 8.55228 11.5523 9 11 9H5C4.44772 9 4 8.55228 4 8ZM9 11C8.44771 11 8 11.4477 8 12C8 12.5523 8.44771 13 9 13H15C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11H9Z" />
    </g>
  ),
})

export const IndentIcon = makeIcon({
  displayName: 'Indent',
  content: (
    <g>
      <path d="M14 1C14 0.447715 14.4477 0 15 0V0C15.5523 0 16 0.447715 16 1V15C16 15.5523 15.5523 16 15 16V16C14.4477 16 14 15.5523 14 15L14 1Z" />
      <path d="M7.46286 10.1213C7.07234 10.5118 7.07234 11.145 7.46286 11.5355C7.85338 11.9261 8.48655 11.9261 8.87707 11.5355L11.7055 8.7071C12.096 8.31658 12.096 7.68341 11.7055 7.29289L8.87707 4.46446C8.48655 4.07394 7.85338 4.07394 7.46286 4.46446C7.07234 4.85499 7.07234 5.48815 7.46286 5.87868L8.58418 6.99999H0.994024C0.44504 6.99999 0 7.44503 0 7.99402C0 8.543 0.445041 8.98804 0.994025 8.98804H8.59614L7.46286 10.1213Z" />
    </g>
  ),
})

export const InfoIcon = makeIcon({
  displayName: 'InfoIcon',
  content: (
    <g>
      <path d="M8,16c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S12.4,16,8,16z M8,14c3.3,0,6-2.7,6-6s-2.7-6-6-6 S2,4.7,2,8S4.7,14,8,14z M8,6.7c0.6,0,1,0.4,1,1v3.7c0,0.6-0.4,1-1,1s-1-0.4-1-1V7.7C7,7.1,7.4,6.7,8,6.7z M8,3.7c0.6,0,1,0.4,1,1 s-0.4,1-1,1s-1-0.4-1-1S7.4,3.7,8,3.7z" />
    </g>
  ),
})

export const InlineCodeIcon = makeIcon({
  displayName: 'InlineCode',
  content: (
    <g>
      <path d="M4.70711 4.29289C5.09763 4.68342 5.09763 5.31658 4.70711 5.70711L2.41421 8L4.70711 10.2929C5.09763 10.6834 5.09763 11.3166 4.70711 11.7071C4.31658 12.0976 3.68342 12.0976 3.29289 11.7071L0.292893 8.70711C-0.0976311 8.31658 -0.0976311 7.68342 0.292893 7.29289L3.29289 4.29289C3.68342 3.90237 4.31658 3.90237 4.70711 4.29289ZM11.2929 4.29289C10.9024 4.68342 10.9024 5.31658 11.2929 5.70711L13.5858 8L11.2929 10.2929C10.9024 10.6834 10.9024 11.3166 11.2929 11.7071C11.6834 12.0976 12.3166 12.0976 12.7071 11.7071L15.7071 8.70711C16.0976 8.31658 16.0976 7.68342 15.7071 7.29289L12.7071 4.29289C12.3166 3.90237 11.6834 3.90237 11.2929 4.29289Z" />
      <path d="M8.05253 4.68022L6.05253 10.6062C5.87593 11.1295 6.15697 11.6969 6.68025 11.8735C7.20354 12.0501 7.77091 11.7691 7.94752 11.2458L9.94752 5.31977C10.1241 4.79649 9.84309 4.22911 9.3198 4.0525C8.79652 3.8759 8.22914 4.15694 8.05253 4.68022Z" />
    </g>
  ),
})

export const IOSIcon = makeIcon({
  displayName: 'IOSIcon',
  viewBox: 24,
  content: (
    <path
      fill="currentColor"
      d="M3.169 23.194A1.714 1.714 0 0 1 .26 21.377l.463-.74c.297-.038.617-.065.991-.065 1.035 0 1.894.327 2.616.762l-1.162 1.86zm-1.454-4.337a1.715 1.715 0 0 1 0-3.428h2.264l6-9.6-2.004-3.205c-.5-.802-.257-1.86.545-2.362.803-.5 1.86-.255 2.363.545L12 2.595 13.118.807A1.712 1.712 0 0 1 15.48.262a1.713 1.713 0 0 1 .545 2.362L8.022 15.43h5.463c.437.314.92.8 1.431 1.613.38.602.564 1.215.667 1.815H1.715zm22.024 2.52A1.716 1.716 0 0 1 22.287 24c-.57 0-1.13-.286-1.455-.806l-7.748-12.397c.137-.34.313-.708.576-1.126a4.97 4.97 0 0 1 1.726-1.66l4.635 7.418h2.265a1.715 1.715 0 0 1 0 3.428h-.122l1.575 2.52z"
    />
  ),
})

export const ItalicIcon = makeIcon({
  displayName: 'ItalicIcon',
  content: (
    <path d="M10.1471 3.15388C10.1471 3.79116 9.63219 4.30777 8.99707 4.30777C8.36194 4.30777 7.84707 3.79116 7.84707 3.15388C7.84707 2.51661 8.36194 2 8.99707 2C9.63219 2 10.1471 2.51661 10.1471 3.15388ZM7.15897 13.907C6.52843 14.2449 5.82804 13.6064 6.03797 12.8851L7.47508 7.94667C7.09713 8.09765 6.66596 7.92183 6.4815 7.52637C6.28399 7.10294 6.4441 6.58806 6.83911 6.37635L8.43844 5.51918C9.06899 5.18123 9.76937 5.81972 9.55944 6.54111L8.12233 11.4795C8.50028 11.3285 8.93145 11.5043 9.11592 11.8998C9.31342 12.3232 9.15331 12.8381 8.7583 13.0498L7.15897 13.907Z" />
  ),
})

export const KeyboardIcon = makeIcon({
  displayName: 'Keyboard',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 4a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1H7a1 1 0 01-1-1V4zM1 9a1 1 0 00-1 1v2a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 00-1-1H1zm6 0a1 1 0 00-1 1v2a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 00-1-1H7zm6 0a1 1 0 00-1 1v2a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 00-1-1h-2z"
      />
    </g>
  ),
})

export const KeyIcon = makeIcon({
  displayName: 'Key',
  viewBox: 13,
  content: (
    <>
      <path d="M5.25 5.03564C5.25 3.5859 6.42525 2.41064 7.875 2.41064C9.32475 2.41064 10.5 3.5859 10.5 5.03564C10.5 6.48539 9.32475 7.66064 7.875 7.66064C7.46079 7.66064 7.125 7.99643 7.125 8.41064C7.125 8.82486 7.46079 9.16064 7.875 9.16064C10.1532 9.16064 12 7.31382 12 5.03564C12 2.75747 10.1532 0.910645 7.875 0.910645C5.59683 0.910645 3.75 2.75747 3.75 5.03564C3.75 5.52408 3.86976 5.98538 3.97599 6.30407L3.98507 6.33107L0 9.95387V12.9106H2.91015L6.49827 9.7212C6.80786 9.44601 6.83575 8.97196 6.56056 8.66237C6.28537 8.35278 5.81131 8.3249 5.50173 8.60009L2.33985 11.4106H1.5V10.6174L5.79991 6.70841L5.54687 6.20234L5.54591 6.20037L5.53852 6.18479C5.53134 6.1694 5.51996 6.14443 5.50576 6.1113C5.47721 6.04467 5.43815 5.94714 5.39901 5.82972C5.31774 5.58591 5.25 5.29721 5.25 5.03564Z" />
      <path d="M7.875 6.16064C8.49632 6.16064 9 5.65697 9 5.03564C9 4.41432 8.49632 3.91064 7.875 3.91064C7.25368 3.91064 6.75 4.41432 6.75 5.03564C6.75 5.65697 7.25368 6.16064 7.875 6.16064Z" />
    </>
  ),
})

export const LeftThinChevronIcon = makeIcon({
  displayName: 'LeftThinChevronIcon',
  content: (
    <path d="M6.41421,8 L12.7071,1.70711 C13.0976,1.31658 13.0976,0.683418 12.7071,0.292893 C12.3166,-0.0976311 11.6834,-0.0976311 11.2929,0.292893 L4.29289,7.29289 C3.90237,7.68342 3.90237,8.31658 4.29289,8.70711 L11.2929,15.7071 C11.6834,16.0976 12.3166,16.0976 12.7071,15.7071 C13.0976,15.3166 13.0976,14.6834 12.7071,14.2929 L6.41421,8 Z" />
  ),
})

export const LinkIcon = makeIcon({
  displayName: 'LinkIcon',
  content: (
    <g>
      <path d="M6.44874212,4.12403316 C6.01773541,3.68927688 6.01773541,2.98441352 6.44874212,2.54965724 L7.52178361,1.46728075 C9.46128621,-0.489093582 12.6057932,-0.489093582 14.5453399,1.46728075 C16.4848867,3.42365619 16.4848867,6.59556357 14.5453399,8.55193901 L13.4722653,9.6343155 C13.0412917,10.0690718 12.3424634,10.0690718 11.9114898,9.6343155 C11.4805162,9.19957035 11.4805162,8.49469586 11.9114898,8.05995071 L12.9845644,6.97757422 C14.0620535,5.89070021 14.0620535,4.12851955 12.9845644,3.04164554 C11.9070752,1.95477153 10.1600704,1.95477153 9.08257023,3.04164554 L8.00952874,4.12403316 C7.57853307,4.55877831 6.87973779,4.55877831 6.44874212,4.12403316 Z M4.87840897,11.1487208 C4.4474133,10.7139979 4.4474133,10.0091346 4.87840897,9.57437829 L9.56079089,4.85127278 C9.99178657,4.41652763 10.6905267,4.41652763 11.1216106,4.85127278 C11.5525842,5.28602906 11.5525842,5.99089242 11.1216106,6.42564871 L6.43920662,11.1487208 C6.00819991,11.583555 5.30941568,11.583555 4.87840897,11.1487208 Z M9.55122229,13.4503586 C9.982229,13.0156357 9.982229,12.3107279 9.55122229,11.876005 C9.12022661,11.4412821 8.42144238,11.4412821 7.99043567,11.876005 L6.91739418,12.9584149 C5.83989396,14.0452777 4.09292234,14.0452777 3.01542212,12.9584149 C1.93791087,11.871552 1.9379219,10.1093268 3.01542212,9.02245278 L4.08846361,7.94007629 C4.51945928,7.50533114 4.51945928,6.80045665 4.08846361,6.3657115 C3.6574569,5.93095521 2.95867266,5.93095521 2.52766595,6.3657115 L1.45462447,7.44808799 C-0.484874822,9.40446343 -0.484874822,12.5763485 1.45462447,14.5327685 C3.39412706,16.4890772 6.5386782,16.4890772 8.4781808,14.5327685 L9.55122229,13.4503586 Z" />
    </g>
  ),
})

export const LockFilledIcon = makeIcon({
  displayName: 'LockFilledIcon',
  content: (
    <path d="M12 4V4.81057L10 4.81023V4C10 2.89543 9.10457 2 8 2C6.89543 2 6 2.89543 6 4V4.80919H4V4C4 1.79086 5.79086 0 8 0C10.2091 0 12 1.79086 12 4ZM4 6.5C2.89543 6.5 2 7.39543 2 8.5V13.5C2 14.6046 2.89543 15.5 4 15.5H12C13.1046 15.5 14 14.6046 14 13.5V8.5C14 7.39543 13.1046 6.5 12 6.5H4Z" />
  ),
})

export const LockIcon = makeIcon({
  displayName: 'LockIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 4.81057V4C12 1.79086 10.2092 0 8 0C5.79083 0 4 1.79086 4 4V4.80919H6V4C6 2.89543 6.89545 2 8 2C9.10455 2 10 2.89543 10 4V4.81023L12 4.81057ZM11 6C12.6569 6 14 7.34315 14 9V13C14 14.6569 12.6569 16 11 16H5C3.34314 16 2 14.6569 2 13V9C2 7.34315 3.34314 6 5 6H11ZM4 9C4 8.44771 4.44769 8 5 8H11C11.5523 8 12 8.44771 12 9V13C12 13.5523 11.5523 14 11 14H5C4.44769 14 4 13.5523 4 13V9Z"
    />
  ),
})

export const LogoutIcon = makeIcon({
  displayName: 'LogoutIcon',
  content: (
    <g>
      <path d="M3 -1.82822e-07C1.34315 -3.27669e-07 -6.26006e-07 1.34314 -7.70853e-07 3L2.62268e-07 13C1.17421e-07 14.6569 1.34315 16 3 16L6 16C7.65685 16 9 14.6569 9 13L9 12.75C9 12.1977 8.55228 11.75 8 11.75C7.44772 11.75 7 12.1977 7 12.75L7 13C7 13.5523 6.55228 14 6 14L3 14C2.44771 14 2 13.5523 2 13L2 3C2 2.44771 2.44772 2 3 2L6 2C6.55228 2 7 2.44771 7 3L7 3.25C7 3.80228 7.44771 4.25 8 4.25C8.55228 4.25 9 3.80228 9 3.25L9 3C9 1.34315 7.65685 -7.29381e-07 6 -8.74228e-07L3 -1.82822e-07ZM11.4629 11.5355C11.0724 11.145 11.0724 10.5118 11.4629 10.1213L12.58 9.00422L5 9.00422C4.44772 9.00422 4 8.5565 4 8.00422C4 7.45193 4.44772 7.00422 5 7.00422L12.5884 7.00422L11.4629 5.87868C11.0724 5.48816 11.0724 4.85499 11.4629 4.46447C11.8534 4.07394 12.4866 4.07394 12.8771 4.46447L15.7055 7.2929C15.8088 7.39614 15.8847 7.51635 15.9334 7.64455C15.9764 7.75616 16 7.87744 16 8.00422C16 8.31306 15.86 8.58919 15.64 8.77263L12.8771 11.5355C12.4866 11.9261 11.8534 11.9261 11.4629 11.5355Z" />
    </g>
  ),
})

export const MailIcon = makeIcon({
  displayName: 'MailIcon',
  content: (
    <path d="M3 1.5C1.34315 1.5 0 2.84315 0 4.5V11.5C0 13.1569 1.34315 14.5 3 14.5H13C14.6569 14.5 16 13.1569 16 11.5V4.5C16 2.84315 14.6569 1.5 13 1.5H3ZM2 4.5C2 3.94772 2.44772 3.5 3 3.5H13C13.5523 3.5 14 3.94772 14 4.5V11.5C14 12.0523 13.5523 12.5 13 12.5H3C2.44772 12.5 2 12.0523 2 11.5V4.5ZM3.10584 5.05224C3.35313 4.55841 3.95393 4.35856 4.44776 4.60584L7.99034 6.37983L11.4712 4.60873C11.9635 4.35828 12.5655 4.55429 12.816 5.04652C13.0664 5.53875 12.8704 6.14082 12.3782 6.39127L8.44741 8.39127C8.16449 8.53522 7.83002 8.53629 7.54618 8.39416L3.55224 6.39416C3.05841 6.14687 2.85856 5.54607 3.10584 5.05224Z" />
  ),
})

export const MediaIcon = makeIcon({
  displayName: 'MediaIcon',
  content: (
    <g>
      <path d="M3 0C1.34315 0 0 1.34315 0 3V13C0 14.6569 1.34315 16 3 16H13C14.6569 16 16 14.6569 16 13V3C16 1.34315 14.6569 0 13 0H3ZM2 3C2 2.44772 2.44772 2 3 2H13C13.5523 2 14 2.44772 14 3V13C14 13.5523 13.5523 14 13 14H3C2.44772 14 2 13.5523 2 13V3ZM7.15277 10.3064L10.3528 8.4314C10.6824 8.23825 10.6824 7.76175 10.3528 7.5686L7.15277 5.6936C6.81945 5.49829 6.4 5.73867 6.4 6.125V9.875C6.4 10.2613 6.81945 10.5017 7.15277 10.3064Z" />
    </g>
  ),
})

export const MoreIcon = makeIcon({
  displayName: 'MoreIcon',
  content: (
    <g>
      <path d="M8 4C9.10455 4 10 3.10457 10 2C10 0.895431 9.10455 0 8 0C6.89545 0 6 0.895431 6 2C6 3.10457 6.89545 4 8 4ZM8 10C9.10455 10 10 9.10457 10 8C10 6.89543 9.10455 6 8 6C6.89545 6 6 6.89543 6 8C6 9.10457 6.89545 10 8 10ZM10 14C10 15.1046 9.10455 16 8 16C6.89545 16 6 15.1046 6 14C6 12.8954 6.89545 12 8 12C9.10455 12 10 12.8954 10 14Z" />
    </g>
  ),
})

export const NewCommentIcon = makeIcon({
  displayName: 'NewCommentIcon',
  content: (
    <g>
      <path d="M13.499 2.5H15C15.553 2.5 16 2.948 16 3.5C16 4.052 15.553 4.5 15 4.5H13.499V6C13.499 6.552 13.051 7 12.499 7C11.946 7 11.499 6.552 11.499 6V4.5H10C9.447 4.5 9 4.052 9 3.5C9 2.948 9.447 2.5 10 2.5H11.499V1C11.499 0.448 11.946 0 12.499 0C13.051 0 13.499 0.448 13.499 1V2.5ZM8 0.25C9.10076 0.25 9.29183 1.89284 8.23255 2.19219C8.09826 2.23014 7.96403 2.252 7.833 2.252C4.562 2.328 2 4.637 2 7.391C2 10.191 4.649 12.531 8 12.531C8.421 12.531 8.836 12.494 9.24 12.422C9.603 12.356 9.976 12.358 10.327 12.471L12.768 13.25V11.085C12.768 10.712 12.911 10.362 13.128 10.059C13.568 9.439 13.853 8.723 13.953 8.033C14.0944 7.07778 15.483 6.39145 15.9558 7.23339C15.9842 7.28389 16 7.33649 16 7.391C16 8.755 15.571 10.068 14.768 11.203L14.893 14.775C14.912 15.328 14.48 15.791 13.929 15.81C13.802 15.814 13.675 15.795 13.556 15.752L9.718 14.375C9.132 14.479 8.569 14.531 8 14.531C3.632 14.531 0 11.39 0 7.391C0 3.392 3.632 0.25 8 0.25Z" />
    </g>
  ),
})

export const NewNoteIcon = makeIcon({
  displayName: 'NewNoteIcon',
  content: (
    <g>
      <path d="M4.25 3.5C3.83579 3.5 3.5 3.83579 3.5 4.25V11.75C3.5 12.1642 3.83579 12.5 4.25 12.5H8.75C9.16421 12.5 9.5 12.1642 9.5 11.75V11C9.5 10.5858 9.83579 10.25 10.25 10.25C10.6642 10.25 11 10.5858 11 11V11.75C11 12.9926 9.99264 14 8.75 14H4.25C3.00736 14 2 12.9926 2 11.75V4.25C2 3.00736 3.00736 2 4.25 2H6C6.41421 2 6.75 2.33579 6.75 2.75C6.75 3.16421 6.41421 3.5 6 3.5H4.25Z" />
      <path d="M10.25 2C10.6642 2 11 2.33579 11 2.75L11 8C11 8.41421 10.6642 8.75 10.25 8.75C9.83579 8.75 9.5 8.41421 9.5 8L9.5 2.75C9.5 2.33579 9.83579 2 10.25 2Z" />
      <path d="M13.625 5.375C13.625 5.78921 13.2892 6.125 12.875 6.125L7.625 6.125C7.21079 6.125 6.875 5.78921 6.875 5.375C6.875 4.96079 7.21079 4.625 7.625 4.625L12.875 4.625C13.2892 4.625 13.625 4.96079 13.625 5.375Z" />
    </g>
  ),
})

export const NewTemplateIcon = makeIcon({
  displayName: 'NewTemplateIcon',
  content: (
    <React.Fragment>
      <g>
        <path d="M2.34315 13.6569C3.11021 14.4239 3.99429 15.0026 4.93792 15.393C5.87938 15.7834 6.91154 15.9992 7.994 16H8.006C10.2061 15.9984 12.1984 15.1086 13.6438 13.6699L13.6569 13.6569C15.1046 12.2091 16 10.2091 16 8C16 7.44772 15.5523 7 15 7C14.4477 7 14 7.44772 14 8C14 9.65685 13.3284 11.1569 12.2426 12.2426L3.75736 3.75736C4.84315 2.67157 6.34315 2 8 2C8.55229 2 9 1.55228 9 1C9 0.447715 8.55229 0 8 0C5.79086 0 3.79086 0.895431 2.34315 2.34315L2.3301 2.35622C1.56962 3.12015 0.995284 3.99942 0.607103 4.93756C0.215911 5.88086 0 6.91521 0 8C0 9.08469 0.215871 10.119 0.606996 11.0622C0.997394 12.0058 1.57611 12.8898 2.34315 13.6569Z" />
        <path d="M12.5 0C11.9477 0 11.5 0.447715 11.5 1V2.5H10C9.44772 2.5 9 2.94772 9 3.5C9 4.05228 9.44772 4.5 10 4.5H11.5V6C11.5 6.55228 11.9477 7 12.5 7C13.0523 7 13.5 6.55228 13.5 6V4.5H15C15.5523 4.5 16 4.05228 16 3.5C16 2.94772 15.5523 2.5 15 2.5H13.5V1C13.5 0.447715 13.0523 0 12.5 0Z" />
      </g>
    </React.Fragment>
  ),
})

export const NoteIcon = makeIcon({
  displayName: 'NoteIcon',
  content: (
    <g>
      <path d="M1 3C1 1.34315 2.34315 0 4 0H12C13.6569 0 15 1.34315 15 3V13C15 14.6569 13.6569 16 12 16H4C2.34315 16 1 14.6569 1 13V3ZM4 2C3.44772 2 3 2.44772 3 3V13C3 13.5523 3.44772 14 4 14H12C12.5523 14 13 13.5523 13 13V3C13 2.44772 12.5523 2 12 2H4Z" />
      <rect x="5" y="4" width="6" height="2" rx="1" />
      <rect x="5" y="7" width="4" height="2" rx="1" />
    </g>
  ),
})

export const NotificationBellIcon = makeIcon({
  displayName: 'NotificationBellIcon',
  content: (
    <path d="M9,13h2c0,1.7-1.3,3-3,3s-3-1.3-3-3h2c0,0.6,0.4,1,1,1S9,13.6,9,13z M14.6,8.7 c0.7,0.9,0.6,2.1-0.3,2.8C13.9,11.8,13.4,12,13,12H3c-1.1,0-2-0.9-2-2c0-0.5,0.2-0.9,0.4-1.3L2.9,7V5c0-2.8,2.3-5,5.1-5 s5.1,2.3,5.1,5V7L14.6,8.7z M11.1,7.7V5c0-1.7-1.4-3-3.1-3S4.9,3.4,4.9,5v2.7L3,10h10L11.1,7.7z" />
  ),
})

export const NudgeIcon = makeIcon({
  displayName: 'NudgeIcon',
  content: (
    <g>
      <path d="M3.4,3.4C3.6,3.2,4,3.1,4.2,3.3c0.3,0.2,0.3,0.6,0.1,0.8C3.1,5.6,3,7.1,4,8.7C4.2,9,4.1,9.3,3.8,9.5 C3.6,9.7,3.2,9.6,3,9.3C1.8,7.3,1.9,5.3,3.4,3.4z M1.7,2.1C1.9,1.8,2.3,1.8,2.5,2s0.3,0.6,0.1,0.8C0.8,5.2,0.7,7.6,2.3,10 c0.2,0.3,0.1,0.6-0.2,0.8c-0.3,0.2-0.6,0.1-0.8-0.2C-0.5,7.8-0.4,4.9,1.7,2.1z M14.6,6.5c0,0.4-0.1,1.6-0.5,3.2 c-0.2,1.1-0.7,2-2,2.7c-0.7,0.4-1.5,0.5-2.3,0.3c-0.8-0.2-1.4-0.7-1.8-1.3l-2.2-4c0-0.1-0.1-0.2,0-0.3C5.9,6.9,6,6.8,6,6.8 c0,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0.1,0,0.2,0.1,0.2,0.2L8.1,10c0.1,0.2,0.4,0.3,0.6,0.2C9,10,9.1,9.8,9,9.5l-1.6-3c0,0,0,0,0,0 L6.8,5.4c0-0.1-0.1-0.2,0-0.3C6.8,5,6.8,5,6.9,4.9c0.2-0.1,0.4,0,0.5,0.1l2.2,4.1c0.1,0.2,0.4,0.3,0.6,0.2c0.2-0.1,0.3-0.4,0.2-0.6 L8.2,4.6c0,0,0,0,0,0L7.8,3.9c0-0.1-0.1-0.2,0-0.3c0-0.1,0.1-0.2,0.2-0.2c0.2-0.1,0.4,0,0.5,0.1L11,8.4c0.1,0.2,0.4,0.3,0.6,0.2 C11.9,8.5,12,8.2,11.9,8L9.7,3.9c0-0.1-0.1-0.2,0-0.3c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2-0.1,0.3,0c0.1,0,0.2,0.1,0.2,0.2l2.3,4.3 l-0.3,0.7c-0.1,0.2,0,0.5,0.2,0.6c0.2,0.1,0.5,0,0.6-0.2L13.5,8c0,0,0,0,0,0l0.8-1.8c0.1-0.1,0.2-0.1,0.2-0.1 C14.6,6.1,14.7,6.4,14.6,6.5 M14.8,4.8c-0.7-0.1-1.4,0.2-1.7,0.9L13,5.8l-1.6-2.9C11,2.1,10,1.8,9.2,2.2C9.1,2.2,9.1,2.3,9,2.3 C8.9,2.2,8.8,2.2,8.6,2.1C8.2,2,7.7,2,7.3,2.2c-0.4,0.2-0.7,0.6-0.8,1c0,0.1-0.1,0.3-0.1,0.4c-0.1,0-0.1,0-0.2,0.1 c-0.7,0.4-1,1.1-0.9,1.9l0,0C4.6,6,4.3,7.1,4.7,7.9l2.2,4C7.5,13.2,9,14,10.6,14c0.8,0,1.5-0.2,2.1-0.5c1.5-0.8,2.3-1.9,2.7-3.6 c0.4-1.6,0.5-3,0.5-3.4C16,5.6,15.6,4.9,14.8,4.8" />
    </g>
  ),
})

export const OrderedListIcon = makeIcon({
  displayName: 'OrderedListIcon',
  content: (
    <g>
      <path d="M1.65002 4.8H2.35559V1.24043H2.27991L0.807739 1.76778V2.34151L1.65002 2.08028V4.8ZM6 2C5.44772 2 5 2.44772 5 3C5 3.55228 5.44771 4 6 4H15C15.5523 4 16 3.55228 16 3C16 2.44772 15.5523 2 15 2H6ZM6 7C5.44772 7 5 7.44772 5 8C5 8.55228 5.44771 9 6 9H15C15.5523 9 16 8.55228 16 8C16 7.44772 15.5523 7 15 7H6ZM5 13C5 12.4477 5.44772 12 6 12H15C15.5523 12 16 12.4477 16 13C16 13.5523 15.5523 14 15 14H6C5.44771 14 5 13.5523 5 13ZM3.07825 9.8H0.641724V9.3166L1.79163 8.09102C1.9495 7.91849 2.06628 7.76794 2.14197 7.63936C2.21765 7.51078 2.25549 7.38871 2.25549 7.27315C2.25549 7.11527 2.21562 6.99117 2.13586 6.90083C2.05611 6.8105 1.94218 6.76534 1.79407 6.76534C1.63456 6.76534 1.50883 6.82027 1.41687 6.93013C1.32491 7.03999 1.27893 7.18444 1.27893 7.36348H0.570923C0.570923 7.14701 0.622599 6.94925 0.725952 6.77022C0.829306 6.59118 0.975382 6.4508 1.16418 6.34908C1.35299 6.24735 1.56702 6.19649 1.80627 6.19649C2.17249 6.19649 2.45691 6.28438 2.65955 6.46016C2.86218 6.63594 2.9635 6.88415 2.9635 7.20479C2.9635 7.38057 2.91793 7.55961 2.82678 7.7419C2.73564 7.92419 2.57939 8.13659 2.35803 8.3791L1.54993 9.23116H3.07825V9.8ZM1.73547 12.7102H1.3595V13.2619H1.73303C2.12366 13.2619 2.31897 13.4393 2.31897 13.7941C2.31897 13.9406 2.27136 14.0582 2.17615 14.1469C2.08093 14.2356 1.9495 14.28 1.78186 14.28C1.63538 14.28 1.51209 14.2377 1.41199 14.153C1.31189 14.0684 1.26184 13.9593 1.26184 13.8259H0.556274C0.556274 14.1335 0.668985 14.3809 0.894409 14.5681C1.11983 14.7552 1.40995 14.8488 1.76477 14.8488C2.144 14.8488 2.44877 14.7536 2.67908 14.5632C2.90938 14.3728 3.02454 14.1197 3.02454 13.8039C3.02454 13.6086 2.9753 13.4393 2.87683 13.2961C2.77836 13.1529 2.62903 13.0454 2.42883 12.9738C2.58997 12.9006 2.72017 12.7956 2.81946 12.6589C2.91874 12.5222 2.96838 12.3724 2.96838 12.2097C2.96838 11.8939 2.86178 11.6461 2.64856 11.4663C2.43534 11.2864 2.14075 11.1965 1.76477 11.1965C1.5483 11.1965 1.35014 11.238 1.17029 11.321C0.990437 11.404 0.850464 11.5192 0.750366 11.6665C0.650268 11.8138 0.60022 11.9802 0.60022 12.1657H1.30579C1.30579 12.0469 1.35136 11.9505 1.4425 11.8764C1.53365 11.8024 1.64677 11.7653 1.78186 11.7653C1.9316 11.7653 2.04919 11.8052 2.13464 11.885C2.22009 11.9647 2.26282 12.0762 2.26282 12.2194C2.26282 12.3675 2.21969 12.4864 2.13342 12.5759C2.04716 12.6654 1.91451 12.7102 1.73547 12.7102Z" />
    </g>
  ),
})

export const OutlineIcon = makeIcon({
  displayName: 'OutlineIcon',
  content: (
    <path d="M1,13h12c0.6,0,1,0.4,1,1s-0.4,1-1,1H1c-0.6,0-1-0.4-1-1S0.4,13,1,13z M4,9h11c0.6,0,1,0.4,1,1 s-0.4,1-1,1H4c-0.6,0-1-0.4-1-1S3.4,9,4,9z M4,5h11c0.6,0,1,0.4,1,1s-0.4,1-1,1H4C3.4,7,3,6.6,3,6S3.4,5,4,5z M1,1h12 c0.6,0,1,0.4,1,1s-0.4,1-1,1H1C0.4,3,0,2.6,0,2S0.4,1,1,1z" />
  ),
})

export const PaperplaneIcon = makeIcon({
  displayName: 'PaperplaneIcon',
  content: (
    <path d="M15.988.558l-1.65 14.716a.537.537 0 0 1-.935.296l-5.25-5.908 4.807-5.815-6.576 4.84L.34 8.386c-.3-.078-.424-.381-.28-.678a.753.753 0 0 1 .343-.338L15.201.076c.313-.155.656-.065.765.2a.477.477 0 0 1 .022.282zm-8.35 15.227a.537.537 0 0 1-.971-.315V10.5l2.666 2.952-1.696 2.333z" />
  ),
})

export const PenCrossedIcon = makeIcon({
  displayName: 'PenCrossedIcon',
  content: (
    <g>
      <path d="M8.3,2.1c0.4-0.4,1-0.4,1.4,0l4.2,4.2c0.4,0.4,0.4,1,0,1.4c-0.4,0.4-1,0.4-1.4,0L8.3,3.5 C7.9,3.1,7.9,2.5,8.3,2.1z" />
      <path d="M11,10.6l-4.8,4.8C5.9,15.8,5.3,16,4.8,16H1c-0.6,0-1-0.4-1-1v-3.8c0-0.5,0.2-1,0.6-1.4L5.4,5l1.4,1.4L2,11.2 V14h2.8l4.8-4.8L11,10.6z M12.4,9.2l2.7-2.7c1.2-1.2,1.2-3.1,0-4.2l-1.4-1.4c-1.2-1.2-3.1-1.2-4.2,0L6.8,3.6L8.2,5l2.7-2.7 c0.4-0.4,1-0.4,1.4,0l1.4,1.4c0.4,0.4,0.4,1,0,1.4L11,7.8L12.4,9.2z" />
      <path d="M13.7,14.7c0.4-0.4,0.4-1,0-1.4l-12-12c-0.4-0.4-1-0.4-1.4,0l0,0c-0.4,0.4-0.4,1,0,1.4l12,12 C12.7,15.1,13.3,15.1,13.7,14.7L13.7,14.7z" />
    </g>
  ),
})

export const PenIcon = makeIcon({
  displayName: 'PenIcon',
  viewBox: 18,
  content: (
    <g>
      <path
        fillRule="evenodd"
        d="M14.707.879a3 3 0 0 0-4.243 0l-8.899 8.9a2 2 0 0 0-.586 1.413v3.829a1 1 0 0 0 1 1h3.829a2 2 0 0 0 1.414-.586l8.9-8.9a3 3 0 0 0 0-4.242L14.706.879zM11.88 2.293a1 1 0 0 1 1.414 0l1.414 1.414a1 1 0 0 1 0 1.414l-.686.687-2.829-2.829.687-.686zm-2.1 2.1l-6.8 6.8v2.828h2.829l6.799-6.8-2.829-2.828z"
      />
    </g>
  ),
})

export const PeopleIcon = makeIcon({
  displayName: 'PeopleIcon',
  content: (
    <g>
      <path d="M8,6c1.1,0,2-0.9,2-2S9.1,2,8,2S6,2.9,6,4S6.9,6,8,6z M8,8C5.8,8,4,6.2,4,4s1.8-4,4-4s4,1.8,4,4 S10.2,8,8,8z M4.5,9h7c1.9,0,3.5,1.6,3.5,3.5V13c0,1.7-1.3,3-3,3H4c-1.7,0-3-1.3-3-3v-0.5C1,10.6,2.6,9,4.5,9z M4.5,11 C3.7,11,3,11.7,3,12.5V13c0,0.6,0.4,1,1,1h8c0.6,0,1-0.4,1-1v-0.5c0-0.8-0.7-1.5-1.5-1.5H4.5z" />
    </g>
  ),
})

export const PieEmptyIcon = makeIcon({
  displayName: 'PieEmptyIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 14C2 7.37258 7.37258 2 14 2V14H2ZM7.7212 7.51964C9.13319 6.11313 11 5.57622 11 5.57622V11H5.55505C5.55505 11 6.3092 8.92616 7.7212 7.51964Z"
    />
  ),
})

export const PieIcon = makeIcon({
  displayName: 'PieIcon',
  content: <path d="M14 2V2C7.37258 2 2 7.37258 2 14V14H14V2Z" />,
})

export const PlanetIcon = makeIcon({
  displayName: 'PlanetIcon',
  content: (
    <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm5.9 7h-2c-.1-1.6-.6-3.1-1.2-4.3 1.7.8 2.9 2.4 3.2 4.3zM2.1 9h2c.1 1.6.6 3.1 1.2 4.3-1.7-.8-2.9-2.4-3.2-4.3zM4 7H2c.3-1.9 1.5-3.5 3.1-4.3C4.7 3.9 4.2 5.4 4 7zm4.6 6.2c-.2.3-.3.6-.4.8h-.4c-.1-.2-.3-.5-.4-.8-.6-1.1-1.2-2.6-1.3-4.2H10c-.2 1.6-.8 3.1-1.4 4.2zM6.1 7c.2-1.6.7-3.1 1.3-4.2.1-.3.3-.6.4-.8h.4c.1.2.3.5.4.8.6 1.1 1.2 2.6 1.3 4.2H6.1zm4.7 6.3c.5-1.2 1-2.7 1.2-4.3h2c-.4 1.9-1.6 3.5-3.2 4.3z" />
  ),
})

export const PlugIcon = makeIcon({
  displayName: 'PlugIcon',
  content: (
    <path d="M7 4.38853C5.13443 4.84455 3.74997 6.52726 3.74997 8.53333V11H2.5C1.94772 11 1.5 11.4477 1.5 12C1.5 12.5523 1.94772 13 2.5 13L3.74997 13H4.99997V14.9333C4.99997 15.5224 5.47753 16 6.06664 16C6.65574 16 7.13331 15.5224 7.13331 14.9333V13H8.99997V15C8.99997 15.5523 9.44769 16 9.99997 16C10.5523 16 11 15.5523 11 15V13H12.2833L13.5 13C14.0523 13 14.5 12.5523 14.5 12C14.5 11.4477 14.0523 11 13.5 11H12.2833V8.53333C12.2833 6.51535 10.8824 4.82458 9 4.38054V4.10743C9 3.51833 9.6109 3 10.2 3H11.8283C13.5077 3 15 1.67937 15 0H13C13 0.501162 12.3295 1 11.8283 1H10.2C8.43269 1 7 2.34012 7 4.10743V4.38853ZM10.25 8.53333V11H5.74997V8.53333C5.74997 7.35512 6.75733 6.4 7.99997 6.4C9.24261 6.4 10.25 7.35512 10.25 8.53333Z" />
  ),
})

export const PlusIcon = makeIcon({
  displayName: 'PlusIcon',
  content: (
    <path d="M7 7V1C7 0.447716 7.44769 0 8 0C8.55231 0 9 0.447716 9 1V7H15C15.5523 7 16 7.44772 16 8C16 8.55228 15.5523 9 15 9H9V15C9 15.5523 8.55231 16 8 16C7.44769 16 7 15.5523 7 15V9H1C0.447693 9 0 8.55228 0 8C0 7.44772 0.447693 7 1 7H7Z" />
  ),
})

export const QuestionIcon = makeIcon({
  displayName: 'QuestionIcon',
  content: (
    <g>
      <path d="M8 16C7.57647 16 7.22059 15.8559 6.93235 15.5676C6.64412 15.2794 6.5 14.9294 6.5 14.5176C6.5 14.0941 6.64412 13.7353 6.93235 13.4412C7.22059 13.1471 7.57647 13 8 13C8.42353 13 8.77941 13.1471 9.06765 13.4412C9.35588 13.7353 9.5 14.0941 9.5 14.5176C9.5 14.9294 9.35588 15.2794 9.06765 15.5676C8.77941 15.8559 8.42353 16 8 16Z" />
      <path d="M3.5 4.50001C3.5 5.05229 3.94772 5.50001 4.5 5.50001C5.05228 5.50001 5.5 5.05229 5.5 4.50001H3.5ZM10.4749 2.02515L11.182 1.31805L11.182 1.31805L10.4749 2.02515ZM7 10.5C7 11.0523 7.44772 11.5 8 11.5C8.55228 11.5 9 11.0523 9 10.5H7ZM8 2.00001C8.69064 2.00001 9.31427 2.27874 9.76778 2.73225L11.182 1.31805C10.3688 0.50479 9.24237 7.62939e-06 8 7.62939e-06V2.00001ZM9.76778 2.73225C10.2213 3.18576 10.5 3.80938 10.5 4.50001H12.5C12.5 3.25765 11.9952 2.13129 11.182 1.31805L9.76778 2.73225ZM10.5 4.50001C10.5 5.19064 10.2213 5.81427 9.76777 6.26777L11.182 7.68199C11.9952 6.86874 12.5 5.74237 12.5 4.50001H10.5ZM5.5 4.50001C5.5 3.80938 5.77873 3.18575 6.23224 2.73224L4.81802 1.31803C4.00478 2.13127 3.5 3.25764 3.5 4.50001H5.5ZM6.23224 2.73224C6.68575 2.27874 7.30937 2.00001 8 2.00001V7.62939e-06C6.75763 7.62939e-06 5.63127 0.504789 4.81802 1.31803L6.23224 2.73224ZM7 10.0856V10.5H9V10.0856H7ZM9.76777 6.26777C9.55953 6.47601 9.31768 6.67743 9.03538 6.90907C8.76675 7.1295 8.45319 7.3838 8.17037 7.65726C7.60127 8.20752 7 8.982 7 10.0856H9C9 9.78646 9.14022 9.50152 9.56058 9.09508C9.77248 8.89019 10.0157 8.69183 10.304 8.45519C10.5788 8.22976 10.8943 7.9697 11.182 7.68199L9.76777 6.26777Z" />
    </g>
  ),
})

export const QuoteIcon = makeIcon({
  displayName: 'QuoteIcon',
  content: (
    <g>
      <path d="M6.42109 2.78574C6.53942 3.3252 6.19802 3.85845 5.65856 3.97678C3.79941 4.38458 2.00008 6.287 2 8.55539C2.5869 7.93943 3.41521 7.55556 4.33318 7.55556C6.11277 7.55556 7.55541 8.9982 7.55541 10.7778C7.55541 12.5574 6.11277 14 4.33318 14L4.3193 14C2.81447 13.9951 1.69817 13.195 0.998367 12.1335C0.313894 11.0953 0 9.78246 0 8.55555C0 5.26846 2.53286 2.61484 5.23005 2.02322C5.76951 1.90489 6.30276 2.24628 6.42109 2.78574ZM14.8211 2.78574C14.9394 3.3252 14.598 3.85845 14.0586 3.97678C12.1994 4.38458 10.4001 6.287 10.4 8.55539C10.9869 7.93943 11.8152 7.55556 12.7332 7.55556C14.5128 7.55556 15.9554 8.9982 15.9554 10.7778C15.9554 12.5574 14.5128 14 12.7332 14L12.7193 14C11.2145 13.9951 10.0982 13.195 9.39839 12.1335C8.71392 11.0953 8.40002 9.78246 8.40002 8.55555C8.40002 5.26846 10.9329 2.61484 13.6301 2.02322C14.1695 1.90489 14.7028 2.24628 14.8211 2.78574Z" />
    </g>
  ),
})

export const RecentIcon = makeIcon({
  displayName: 'RecentIcon',
  content: (
    <g>
      <path d="M9,8h2c0.6,0,1,0.4,1,1s-0.4,1-1,1H8c-0.6,0-1-0.4-1-1V5c0-0.6,0.4-1,1-1s1,0.4,1,1V8z M8,16 c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S12.4,16,8,16z M8,14c3.3,0,6-2.7,6-6s-2.7-6-6-6S2,4.7,2,8S4.7,14,8,14z" />
    </g>
  ),
})

export const RecurringIcon = makeIcon({
  displayName: 'RecurringIcon',
  content: (
    <g>
      <path d="M15 2.5C14.4477 2.5 14 2.9477 14 3.49999V6H11.5C10.9477 6 10.5 6.44772 10.5 7C10.5 7.55228 10.9477 8 11.5 8H15C15.5523 8 16 7.55228 16 7V3.49999C16 2.9477 15.5523 2.5 15 2.5Z" />
      <path d="M7.5 2.5C6.75241 2.5 6.04205 2.6486 5.39495 2.91694C4.72135 3.19627 4.11436 3.6062 3.60603 4.1158C3.10095 4.62214 2.69448 5.22567 2.41694 5.89496C2.1486 6.54206 2 7.25241 2 8C2 8.74759 2.1486 9.45794 2.41694 10.105C2.69537 10.7765 3.10357 11.3817 3.61091 11.8891C4.11825 12.3964 4.72352 12.8046 5.39497 13.0831C6.04206 13.3514 6.75242 13.5 7.5 13.5C8.24758 13.5 8.95794 13.3514 9.60503 13.0831C10.2743 12.8055 10.8779 12.3991 11.3842 11.894C11.7752 11.5039 12.4084 11.5047 12.7984 11.8957C13.1884 12.2867 13.1877 12.9199 12.7966 13.3099C12.1079 13.9969 11.2856 14.5513 10.3711 14.9305C9.48545 15.2978 8.51508 15.5 7.5 15.5C6.48493 15.5 5.51456 15.2978 4.62888 14.9305C3.71143 14.5501 2.88677 13.9934 2.19669 13.3033C1.50663 12.6132 0.949926 11.7886 0.569484 10.8711C0.20221 9.98546 0 9.01508 0 8C0 6.98492 0.202209 6.01454 0.569484 5.12886C0.948704 4.21436 1.50306 3.39207 2.19005 2.70336C2.88147 2.01021 3.70846 1.45115 4.62884 1.06949C5.51453 0.702212 6.48491 0.5 7.5 0.5C8.51509 0.5 9.48547 0.702212 10.3712 1.06949C11.2886 1.44993 12.1132 2.00663 12.8033 2.69669C13.4934 3.38676 14.0501 4.21142 14.4305 5.12886C14.6421 5.63902 14.4 6.22408 13.8898 6.43564C13.3797 6.64719 12.7946 6.40512 12.5831 5.89496C12.3046 5.22351 11.8964 4.61825 11.3891 4.11091C10.8817 3.60358 10.2765 3.19538 9.60506 2.91694C8.95795 2.6486 8.24759 2.5 7.5 2.5Z" />
      <path d="M8.00003 4C8.55231 4 9.00003 4.44772 9.00003 5V8.5C9.00003 8.85126 8.81573 9.17677 8.51452 9.35749L6.01452 10.8575C5.54094 11.1416 4.92668 10.9881 4.64254 10.5145C4.35839 10.0409 4.51195 9.42666 4.98553 9.14251L7.00003 7.93381V5C7.00003 4.44772 7.44774 4 8.00003 4Z" />
    </g>
  ),
})

export const RedoIcon = makeIcon({
  displayName: 'Redo',
  content: (
    <g>
      <path d="M15 2C14.4477 2 14 2.44772 14 3V6H11C10.4477 6 10 6.44772 10 7C10 7.55228 10.4477 8 11 8H15C15.5523 8 16 7.55228 16 7V3C16 2.44772 15.5523 2 15 2Z" />
      <path d="M7.5 2.5C6.75241 2.5 6.04205 2.6486 5.39495 2.91694C4.72135 3.19627 4.11436 3.6062 3.60603 4.1158C3.10095 4.62214 2.69448 5.22567 2.41694 5.89496C2.1486 6.54206 2 7.25241 2 8C2 8.74759 2.1486 9.45794 2.41694 10.105C2.69537 10.7765 3.10357 11.3817 3.61091 11.8891C4.11825 12.3964 4.72352 12.8046 5.39497 13.0831C6.04206 13.3514 6.75242 13.5 7.5 13.5C8.24758 13.5 8.95794 13.3514 9.60503 13.0831C10.2743 12.8055 10.8779 12.3991 11.3842 11.894C11.7752 11.5039 12.4084 11.5047 12.7984 11.8957C13.1884 12.2867 13.1877 12.9199 12.7966 13.3099C12.1079 13.9969 11.2856 14.5513 10.3711 14.9305C9.48545 15.2978 8.51508 15.5 7.5 15.5C6.48493 15.5 5.51456 15.2978 4.62888 14.9305C3.71143 14.5501 2.88677 13.9934 2.19669 13.3033C1.50663 12.6132 0.949926 11.7886 0.569484 10.8711C0.20221 9.98546 0 9.01508 0 8C0 6.98492 0.202209 6.01454 0.569484 5.12886C0.948704 4.21436 1.50306 3.39207 2.19005 2.70336C2.88147 2.01021 3.70846 1.45115 4.62884 1.06949C5.51453 0.702212 6.48491 0.5 7.5 0.5C8.51509 0.5 9.48547 0.702212 10.3712 1.06949C11.2886 1.44993 12.1132 2.00663 12.8033 2.69669C13.4934 3.38676 14.0501 4.21142 14.4305 5.12886C14.6421 5.63902 14.4 6.22408 13.8898 6.43564C13.3797 6.64719 12.7946 6.40512 12.5831 5.89496C12.3046 5.22351 11.8964 4.61825 11.3891 4.11091C10.8817 3.60358 10.2765 3.19538 9.60506 2.91694C8.95795 2.6486 8.24759 2.5 7.5 2.5Z" />
    </g>
  ),
})

export const ReturnArrowIcon = makeIcon({
  displayName: 'ReturnArrow',
  content: (
    <path d="M3.41581,10.1 L14,10.1 L14,2.10001 C14,1.54772 14.4477,1.10001 15,1.10001 C15.5523,1.10001 16,1.54772 16,2.10001 L16,11.1 C16,11.6523 15.5523,12.1 15,12.1 L3.4158,12.1 L4.53712,13.2213 C4.92765,13.6119 4.92765,14.245 4.53712,14.6355 C4.1466,15.0261 3.51343,15.0261 3.12291,14.6355 L0.327288,11.8399 C0.126217,11.657 0,11.3932 0,11.1 C0,10.8067 0.126244,10.543 0.327351,10.36 L3.12291,7.56448 C3.51343,7.17395 4.1466,7.17395 4.53712,7.56448 C4.92765,7.955 4.92765,8.58816 4.53712,8.97869 L3.41581,10.1 Z" />
  ),
})

export const SearchIcon = makeIcon({
  displayName: 'SearchIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 11C4.01472 11 2 8.98528 2 6.5C2 4.01472 4.01472 2 6.5 2C8.98528 2 11 4.01472 11 6.5C11 8.98528 8.98528 11 6.5 11ZM6.5 13C2.91015 13 0 10.0899 0 6.5C0 2.91015 2.91015 0 6.5 0C10.0899 0 13 2.91015 13 6.5C13 7.94774 12.5267 9.28493 11.7264 10.3653C11.8088 10.4169 11.8875 10.4791 11.9601 10.5517L15.6316 14.2232C16.0822 14.6738 16.1309 15.3557 15.7404 15.7462C15.3499 16.1367 14.668 16.088 14.2174 15.6374L10.5459 11.9659C10.4729 11.893 10.4105 11.814 10.3588 11.7311C9.27961 12.5286 7.94486 13 6.5 13Z"
    />
  ),
})

export const SearchSmallIcon = makeIcon({
  displayName: 'SearchSmallIcon',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.875 10.25C5.01104 10.25 3.5 8.73896 3.5 6.875C3.5 5.01104 5.01104 3.5 6.875 3.5C8.73896 3.5 10.25 5.01104 10.25 6.875C10.25 8.73896 8.73896 10.25 6.875 10.25ZM6.875 11.75C4.18261 11.75 2 9.56739 2 6.875C2 4.18261 4.18261 2 6.875 2C9.56739 2 11.75 4.18261 11.75 6.875C11.75 7.96081 11.395 8.96371 10.7948 9.77397C10.8566 9.81267 10.9156 9.85931 10.9701 9.91378L13.7237 12.6674C14.0617 13.0054 14.0982 13.5168 13.8053 13.8097C13.5124 14.1026 13.001 14.066 12.663 13.7281L9.9094 10.9744C9.8547 10.9197 9.8079 10.8605 9.76912 10.7984C8.9597 11.3964 7.95864 11.75 6.875 11.75Z"
    />
  ),
})

export const SeparatorIcon = makeIcon({
  displayName: 'Separator',
  content: (
    <g>
      <path d="M1,7h14c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1H1C0.4,9,0,8.6,0,8l0,0C0,7.4,0.4,7,1,7z" />
    </g>
  ),
})

export const ShareIcon = makeIcon({
  displayName: 'ShareIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 16C1.34315 16 1.74781e-07 14.6568 1.55023e-07 13L1.19249e-07 9.99999C9.94909e-08 8.34314 1.34315 6.99999 3 6.99999L3.25 6.99999C3.80228 6.99999 4.25 7.44771 4.25 7.99999C4.25 8.55228 3.80228 8.99999 3.25 8.99999L3 8.99999C2.44771 8.99999 2 9.44771 2 9.99999L2 13C2 13.5523 2.44772 14 3 14L13 14C13.5523 14 14 13.5523 14 13L14 9.99999C14 9.44771 13.5523 8.99999 13 8.99999L12.75 8.99999C12.1977 8.99999 11.75 8.55228 11.75 7.99999C11.75 7.44771 12.1977 6.99999 12.75 6.99999L13 6.99999C14.6569 6.99999 16 8.34314 16 9.99999L16 13C16 14.6568 14.6569 16 13 16L3 16ZM8.00421 12C8.5565 12 9.00421 11.5523 9.00421 11L9.00421 3.42004L10.1213 4.53712C10.5118 4.92764 11.145 4.92764 11.5355 4.53712C11.926 4.1466 11.926 3.51343 11.5355 3.12291L8.77271 0.360106C8.58927 0.140046 8.3131 9.16654e-08 8.00421 9.53488e-08C7.87816 9.6852e-08 7.75756 0.0233223 7.64648 0.065887C7.51755 0.114509 7.39664 0.190707 7.29287 0.29448L4.46444 3.12291C4.07392 3.51343 4.07392 4.1466 4.46444 4.53712C4.85496 4.92764 5.48813 4.92764 5.87865 4.53712L7.00421 3.41156L7.00421 11C7.00421 11.5523 7.45193 12 8.00421 12Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const ShrinkIcon = makeIcon({
  displayName: 'ShrinkIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.23926 1.32541C6.23926 0.773122 5.79154 0.326416 5.23926 0.326416C4.68697 0.326416 4.23926 0.77413 4.23926 1.32642L4.23926 2.89379L1.73926 0.326416C1.36719 -0.0817318 0.734702 -0.110981 0.326554 0.261086C-0.0815935 0.633153 -0.110842 1.26564 0.261225 1.67379L2.84275 4.32489H1.24002C0.687314 4.32489 0.239258 4.77295 0.239258 5.32566C0.239258 5.87836 0.687314 6.32642 1.24002 6.32642L5.23926 6.32642C5.79154 6.32642 6.23926 5.8787 6.23926 5.32642L6.23926 1.32541Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6748 6.23901C15.2271 6.23901 15.6738 5.7913 15.6738 5.23901C15.6738 4.68673 15.2261 4.23901 14.6738 4.23901L13.1064 4.23901L15.6738 1.73901C16.082 1.36695 16.1112 0.734458 15.7392 0.32631C15.3671 -0.0818377 14.7346 -0.111086 14.3265 0.260981L11.6753 2.84251V1.23977C11.6753 0.687069 11.2273 0.239014 10.6746 0.239014C10.1219 0.239014 9.67383 0.68707 9.67383 1.23977V5.23901C9.67383 5.7913 10.1215 6.23901 10.6738 6.23901L14.6748 6.23901Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.71729 14.6746C9.71729 15.2269 10.165 15.6736 10.7173 15.6736C11.2696 15.6736 11.7173 15.2259 11.7173 14.6736V13.1062L14.2173 15.6736C14.5894 16.0817 15.2218 16.111 15.63 15.7389C16.0381 15.3668 16.0674 14.7344 15.6953 14.3262L13.1138 11.6751H14.7165C15.2692 11.6751 15.7173 11.227 15.7173 10.6743C15.7173 10.1216 15.2692 9.67358 14.7165 9.67358H10.7173C10.165 9.67358 9.71729 10.1213 9.71729 10.6736V14.6746Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.32516 9.76099C0.772878 9.76099 0.326172 10.2087 0.326172 10.761C0.326172 11.3133 0.773886 11.761 1.32617 11.761H2.89355L0.326172 14.261C-0.0819759 14.6331 -0.111225 15.2655 0.260842 15.6737C0.632909 16.0818 1.2654 16.1111 1.67355 15.739L4.32465 13.1575L4.32465 14.7602C4.32465 15.3129 4.77271 15.761 5.32541 15.761C5.87812 15.761 6.32617 15.3129 6.32617 14.7602L6.32617 10.761C6.32617 10.2087 5.87846 9.76099 5.32617 9.76099L1.32516 9.76099Z"
      />
    </g>
  ),
})

export const SlackIcon = makeIcon({
  displayName: 'SlackIcon',
  content: (
    <g>
      <path
        d="M7.56 1.68v1.68H5.88a1.68 1.68 0 1 1 1.68-1.68z"
        fill="#36C5F0"
      />
      <path
        d="M14.32 7.56h-1.68V5.88a1.68 1.68 0 1 1 1.68 1.68zM11.79 5.88a1.68 1.68 0 1 1-3.36-.001l.001-4.199a1.68 1.68 0 0 1 3.361.001l-.001 4.2z"
        fill="#2EB67D"
      />
      <path
        d="M8.446 14.32v-1.68h1.68a1.68 1.68 0 1 1-1.68 1.68zM10.117 11.79a1.68 1.68 0 1 1 0-3.36l4.202-.001a1.68 1.68 0 1 1 0 3.361h-4.202z"
        fill="#ECB22E"
      />
      <path
        d="M1.68 8.44h1.68v1.68a1.68 1.68 0 1 1-1.68-1.68zM4.22 10.12a1.68 1.68 0 0 1 3.36.001l-.001 4.199a1.68 1.68 0 0 1-3.361-.001l.001-4.2z"
        fill="#E01E5A"
      />
      <path
        d="M5.88 4.22a1.68 1.68 0 0 1-.001 3.36L1.68 7.579a1.68 1.68 0 1 1 .001-3.361l4.2.001z"
        fill="#36C5F0"
      />
    </g>
  ),
})

export const SlackIconMonochrome = makeIcon({
  displayName: 'SlackIconMonochrome',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.888 3.362a1.681 1.681 0 1 1 1.68-1.681v1.68h-1.68zm-2.81 7.684c.184-.276.283-.601.283-.934v-1.68H1.68a1.681 1.681 0 1 0 1.398 2.614zm1.63-2.108a1.68 1.68 0 0 0-.5 1.174l.002 4.207a1.681 1.681 0 0 0 3.36 0v-4.207a1.681 1.681 0 0 0-2.861-1.174zm2.353-4.23a1.68 1.68 0 0 0-1.174-.5L1.68 4.21a1.681 1.681 0 0 0 0 3.36h4.207a1.681 1.681 0 0 0 1.174-2.861zm5.579 1.18a1.681 1.681 0 1 1 1.68 1.68h-1.68v-1.68zM11.28 7.04c.313-.303.496-.716.511-1.152l.002-4.207a1.68 1.68 0 0 0-3.362 0v4.207a1.681 1.681 0 0 0 2.848 1.152zm-1.169 5.6a1.68 1.68 0 1 1-1.68 1.681v-1.68h1.68zM8.96 11.28c.303.314.716.497 1.152.512l4.207.001a1.68 1.68 0 0 0 0-3.361h-4.207A1.681 1.681 0 0 0 8.96 11.28z"
      />
    </g>
  ),
})

export const SparklesIcon = makeIcon({
  displayName: 'SparklesIcon',
  content: (
    <g>
      <path d="M5.8 1.1c0-.1.1-.1.2-.2.1 0 .2.1.2.2l.6 3.3C7 5.8 8.1 7 9.6 7.4l1.6.4c.1 0 .1.1.1.1 0 .1 0 .2-.1.2l-1.6.5c-1.5.4-2.6 1.6-2.8 3l-.6 3.3c0 .1-.1.1-.2.2-.1 0-.2-.1-.2-.2l-.6-3.3C5 10.2 3.9 9 2.4 8.6L.8 8.2C.7 8.2.6 8.1.6 8s0-.2.1-.2l1.6-.4C3.9 7 5 5.8 5.2 4.4l.6-3.3zm6.6 7.3c.1-.1.2 0 .2 0l.4 1.8c.1.7.7 1.2 1.4 1.4l1.2.3s.1 0 .1.1c0 0 0 .1-.1.1l-1.2.3c-.7.2-1.2.7-1.4 1.4l-.4 1.8s0 .1-.1.1c0 0-.1 0-.1-.1l-.4-1.8c-.1-.7-.7-1.2-1.4-1.4l-1.2-.3s-.1 0-.1-.1c0 0 0-.1.1-.1l1.2-.3c.7-.2 1.2-.7 1.4-1.4l.4-1.8zM10.9.3c0-.1.1-.1 0 0 .1-.1.1 0 .1 0l.3 1.1c.1.5.5.8 1 .9l.9.2v.1l-.9.2c-.5.1-.9.5-1 .9L11 4.8h-.1l-.3-1.1c-.1-.5-.5-.8-1-.9l-.8-.2v-.1l.9-.2c.5-.1.9-.5 1-.9l.2-1.1z" />
    </g>
  ),
})

export const SpeakerIcon = makeIcon({
  displayName: 'SpeakerIcon',
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 7C11 5.74087 11.2573 4.65038 11.6267 3.91168C12.0259 3.11316 12.3925 3 12.5 3C12.6076 3 12.9741 3.11316 13.3734 3.91168C13.7427 4.65038 14 5.74087 14 7C14 8.25913 13.7427 9.34962 13.3734 10.0883C12.9741 10.8868 12.6076 11 12.5 11C12.3925 11 12.0259 10.8868 11.6267 10.0883C11.2573 9.34962 11 8.25913 11 7ZM9.44731 3.98204L3.08556 6.10262C2.17387 6.40652 2.17387 7.69609 3.08557 7.99999L9.45434 10.0396C9.16038 9.13892 9.00003 8.09406 9.00003 7C9.00003 5.9147 9.15782 4.87783 9.44731 3.98204ZM11.9981 1.05421C11.9191 1.06055 11.8396 1.07644 11.761 1.10262L2.45311 4.20526C-0.199133 5.08934 -0.279461 8.75399 2.21209 9.80653L4.05134 15.3165C4.22599 15.8404 4.79231 16.1236 5.31626 15.949C5.8402 15.7743 6.12336 15.208 5.94871 14.684L4.57805 10.5779L11.7004 12.8589C11.9474 12.9492 12.2138 13 12.5 13C13.7732 13 14.6567 11.9939 15.1622 10.9827C15.6977 9.91181 16 8.5023 16 7C16 5.49771 15.6977 4.08819 15.1622 3.01725C14.6567 2.00613 13.7732 1 12.5 1C12.3254 1 12.1581 1.01893 11.9981 1.05421Z"
      />
    </g>
  ),
})

export const SpinnerIcon = makeIcon({
  displayName: 'Spinner',
  content: (
    <g>
      <path d="M8,16c-4.4,0-8-3.6-8-8s3.6-8,8-8c2,0,4,0.8,5.5,2.2c0.4,0.4,0.4,1,0,1.4s-1,0.4-1.4,0 C11,2.6,9.5,2,8,2C4.7,2,2,4.7,2,8s2.7,6,6,6s6-2.7,6-6c0-0.6,0.4-1,1-1s1,0.4,1,1C16,12.4,12.4,16,8,16z" />
    </g>
  ),
})

export const SquareEmptyIcon = makeIcon({
  displayName: 'SquareEmptyIcon',
  content: (
    <path d="M3,2 L13,2 C13.5522847,2 14,2.44771525 14,3 L14,13 C14,13.5522847 13.5522847,14 13,14 L3,14 C2.44771525,14 2,13.5522847 2,13 L2,3 C2,2.44771525 2.44771525,2 3,2 Z M5,5 L5,11 L11,11 L11,5 L5,5 Z" />
  ),
})

export const SquareIcon = makeIcon({
  displayName: 'SquareIcon',
  content: <rect x="2" y="2" width="12" height="12" rx="1" />,
})

export const PlaceholderIcon = makeIcon({
  displayName: 'PlaceholderIcon',
  content: (
    <path d="M0 3c0 .6.4 1 1 1s1-.4 1-1 .4-1 1-1 1-.4 1-1-.4-1-1-1C1.3 0 0 1.3 0 3zm6-1h4c.6 0 1-.4 1-1s-.4-1-1-1H6c-.6 0-1 .4-1 1s.4 1 1 1zm-5 9c-.6 0-1-.4-1-1V6c0-.6.4-1 1-1s1 .4 1 1v4c0 .6-.4 1-1 1zm-1 2c0 1.7 1.3 3 3 3 .6 0 1-.4 1-1s-.4-1-1-1-1-.4-1-1-.4-1-1-1-1 .4-1 1zm10 3H6c-.6 0-1-.4-1-1s.4-1 1-1h4c.6 0 1 .4 1 1s-.4 1-1 1zm2-1c0 .6.4 1 1 1 1.7 0 3-1.3 3-3 0-.6-.4-1-1-1s-1 .4-1 1-.4 1-1 1-1 .4-1 1zm3-4c-.6 0-1-.4-1-1V6c0-.6.4-1 1-1s1 .4 1 1v4c0 .6-.4 1-1 1zm-1-8c0 .6.4 1 1 1s1-.4 1-1c0-1.7-1.3-3-3-3-.6 0-1 .4-1 1s.4 1 1 1 1 .4 1 1z" />
  ),
})

export const StrikethroughIcon = makeIcon({
  displayName: 'Strikethrough',
  content: (
    <g>
      <path d="M12.6 3.8C13.0418 3.46863 13.1314 2.84183 12.8 2.4C11.6002 0.800254 9.7996 0 7.49998 0C4.1977 0 1.99998 2.19772 1.99998 5C1.99998 6.97704 3.36439 8.24429 5.56883 8.75H13.2104C12.2231 7.59133 10.3706 6.99883 7.99949 7C5.36807 7.00129 3.99998 6.22161 3.99998 5C3.99998 3.30228 5.30227 2 7.49998 2C9.20036 2 10.3998 2.53308 11.2 3.6C11.5314 4.04183 12.1582 4.13137 12.6 3.8ZM13.9927 10.75H11.9805C11.9936 10.8308 12.0001 10.9139 12 10.9992C11.9987 12.5611 10.3169 14 7.99998 14C6.35432 14 4.98907 13.1809 3.83203 11.4453C3.52568 10.9858 2.90481 10.8616 2.44528 11.1679C1.98576 11.4743 1.86158 12.0952 2.16793 12.5547C3.67757 14.8191 5.64565 16 7.99998 16C11.358 16 13.9977 13.7414 14 11.0008C14.0001 10.9159 13.9976 10.8323 13.9927 10.75Z" />
      <path d="M0 8C0 7.44772 0.447715 7 1 7H15C15.5523 7 16 7.44772 16 8V8C16 8.55228 15.5523 9 15 9H1C0.447715 9 0 8.55228 0 8V8Z" />
    </g>
  ),
})

export const TagIcon = makeIcon({
  displayName: 'TagIcon',
  content: (
    <path
      d="M13.1548 0.380662C12.9673 0.193125 12.713 0.0877686 12.4477 0.0877686H8.91221C8.64699 0.0877686 8.39264 0.193125 8.2051 0.380662L0.426927 8.15884C0.0364019 8.54936 0.0364022 9.18253 0.426927 9.57305L6.43733 15.5835C6.82786 15.974 7.46102 15.974 7.85155 15.5835L15.6297 7.80528C15.8173 7.61775 15.9226 7.36339 15.9226 7.09818V3.56264C15.9226 3.29743 15.8173 3.04307 15.6297 2.85554L13.1548 0.380662ZM9.32642 2.08777H12.0335L13.9226 3.97686V6.68396L7.14444 13.4621L2.54825 8.86594L9.32642 2.08777ZM10.1496 5.86074C10.5401 6.25127 11.1733 6.25127 11.5638 5.86074C11.9544 5.47022 11.9544 4.83705 11.5638 4.44653C11.1733 4.056 10.5401 4.056 10.1496 4.44653C9.7591 4.83705 9.7591 5.47022 10.1496 5.86074Z"
      fill="currentColor"
    />
  ),
})

export const TemplateIcon = makeIcon({
  displayName: 'TemplateIcon',
  content: (
    <g>
      <path d="M4.93792 15.393C3.99429 15.0026 3.11021 14.4239 2.34315 13.6569C1.57611 12.8898 0.997394 12.0058 0.606996 11.0622C0.215871 10.119 0 9.08469 0 8C0 6.91521 0.215911 5.88086 0.607103 4.93756C0.995284 3.99942 1.56962 3.12015 2.3301 2.35622C2.33445 2.35186 2.33879 2.3475 2.34315 2.34315C3.79086 0.895431 5.79086 0 8 0C12.4183 0 16 3.58172 16 8C16 10.2091 15.1046 12.2091 13.6569 13.6569C13.6525 13.6612 13.6481 13.6656 13.6438 13.6699C12.1984 15.1086 10.2061 15.9984 8.006 16H7.994C6.91154 15.9992 5.87938 15.7834 4.93792 15.393ZM3.75736 3.75736L12.2426 12.2426C13.3284 11.1569 14 9.65685 14 8C14 4.68629 11.3137 2 8 2C6.34315 2 4.84315 2.67157 3.75736 3.75736Z" />
    </g>
  ),
})

export const ThinChevronIcon = makeIcon({
  displayName: 'ThinChevronIcon',
  content: (
    <path d="M10.5858 8L4.29289 1.70711C3.90237 1.31658 3.90237 0.683418 4.29289 0.292893C4.68342 -0.0976311 5.31658 -0.0976311 5.70711 0.292893L12.7071 7.29289C13.0976 7.68342 13.0976 8.31658 12.7071 8.70711L5.70711 15.7071C5.31658 16.0976 4.68342 16.0976 4.29289 15.7071C3.90237 15.3166 3.90237 14.6834 4.29289 14.2929L10.5858 8Z" />
  ),
})

export const ThinCircleEmptyIcon = makeIcon({
  displayName: 'ThinCircleEmptyIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12ZM8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
    />
  ),
})

export const ToolbarMoreIcon = makeIcon({
  displayName: 'ToolbarMoreIcon',
  content: (
    <g>
      <path d="M7.25 5.75C7.25 5.33579 7.58579 5 8 5C8.41421 5 8.75 5.33579 8.75 5.75V10.25C8.75 10.6642 8.41421 11 8 11C7.58579 11 7.25 10.6642 7.25 10.25V5.75Z" />
      <path d="M5 8C5 7.58579 5.33579 7.25 5.75 7.25H10.25C10.6642 7.25 11 7.58579 11 8C11 8.41421 10.6642 8.75 10.25 8.75H5.75C5.33579 8.75 5 8.41421 5 8Z" />
      <path d="M0 3C0 1.34315 1.34315 0 3 0H13C14.6569 0 16 1.34315 16 3V13C16 14.6569 14.6569 16 13 16H3C1.34315 16 0 14.6569 0 13V3ZM3 2C2.44772 2 2 2.44772 2 3V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13V3C14 2.44772 13.5523 2 13 2H3Z" />
    </g>
  ),
})

export const TriangleEmptyIcon = makeIcon({
  displayName: 'TriangleEmptyIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.70705,2.29484211 C3.07706,1.66495211 2,2.11114211 2,3.00200211 L2,12.9985021 C2,13.5508021 2.44772,13.9985021 3,13.9985021 L12.9981,13.9985021 C13.8891,13.9985021 14.3352,12.9213021 13.7052,12.2913021 L3.70705,2.29484211 Z M8.23484,11.0184021 L4.98055,7.77322211 L4.98055,11.0184021 L8.23484,11.0184021 Z"
    />
  ),
})

export const TriangleIcon = makeIcon({
  displayName: 'TriangleIcon',
  content: (
    <path d="M2 2.90072C2 2.00981 3.07714 1.56365 3.70711 2.19361L13.8064 12.2929C14.4364 12.9229 13.9902 14 13.0993 14H3C2.44772 14 2 13.5523 2 13V2.90072Z" />
  ),
})

export const UndentIcon = makeIcon({
  displayName: 'Undent',
  content: (
    <g>
      <path d="M2 15C2 15.5523 1.55228 16 0.999999 16V16C0.447714 16 -1.35962e-06 15.5523 -1.31134e-06 15L-8.74228e-08 1C-3.91405e-08 0.447715 0.447715 -1.35705e-07 1 -8.74228e-08V-8.74228e-08C1.55228 -3.91405e-08 2 0.447715 2 1L2 15Z" />
      <path d="M8.53714 5.87868C8.92766 5.48816 8.92766 4.85499 8.53714 4.46447C8.14662 4.07394 7.51345 4.07394 7.12293 4.46447L4.2945 7.29289C3.90397 7.68342 3.90397 8.31658 4.2945 8.70711L7.12293 11.5355C7.51345 11.9261 8.14662 11.9261 8.53714 11.5355C8.92766 11.145 8.92766 10.5118 8.53714 10.1213L7.41582 9.00001L15.006 9.00001C15.555 9.00001 16 8.55497 16 8.00598C16 7.457 15.555 7.01196 15.006 7.01196L7.40386 7.01196L8.53714 5.87868Z" />
    </g>
  ),
})

export const UnderlineIcon = makeIcon({
  displayName: 'Underline',
  content: (
    <g>
      <path d="M2.5 1C2.5 0.447715 2.94772 0 3.5 0V0C4.05228 0 4.5 0.447715 4.5 1V6.5C4.5 8.433 6.067 10 8 10V10C9.933 10 11.5 8.433 11.5 6.5V1C11.5 0.447716 11.9477 0 12.5 0V0C13.0523 0 13.5 0.447715 13.5 1V6.5C13.5 9.53757 11.0376 12 8 12V12C4.96243 12 2.5 9.53757 2.5 6.5V1Z" />
      <path d="M1 15C1 14.4477 1.44772 14 2 14H14C14.5523 14 15 14.4477 15 15V15C15 15.5523 14.5523 16 14 16H2C1.44772 16 1 15.5523 1 15V15Z" />
    </g>
  ),
})

export const UndoIcon = makeIcon({
  displayName: 'Undo',
  content: (
    <g>
      <path d="M1 2C1.55228 2 2 2.44772 2 3V6H5C5.55228 6 6 6.44772 6 7C6 7.55228 5.55228 8 5 8H1C0.447715 8 0 7.55228 0 7V3C0 2.44772 0.447715 2 1 2Z" />
      <path d="M8.5 2.5C9.24759 2.5 9.95795 2.6486 10.6051 2.91694C11.2787 3.19627 11.8856 3.6062 12.394 4.1158C12.899 4.62214 13.3055 5.22567 13.5831 5.89496C13.8514 6.54206 14 7.25241 14 8C14 8.74759 13.8514 9.45794 13.5831 10.105C13.3046 10.7765 12.8964 11.3817 12.3891 11.8891C11.8817 12.3964 11.2765 12.8046 10.605 13.0831C9.95794 13.3514 9.24758 13.5 8.5 13.5C7.75242 13.5 7.04206 13.3514 6.39497 13.0831C5.72568 12.8055 5.12214 12.3991 4.6158 11.894C4.22479 11.5039 3.59163 11.5047 3.20159 11.8957C2.81155 12.2867 2.81234 12.9199 3.20335 13.3099C3.89207 13.9969 4.71437 14.5513 5.62887 14.9305C6.51455 15.2978 7.48492 15.5 8.5 15.5C9.51507 15.5 10.4854 15.2978 11.3711 14.9305C12.2886 14.5501 13.1132 13.9934 13.8033 13.3033C14.4934 12.6132 15.0501 11.7886 15.4305 10.8711C15.7978 9.98546 16 9.01508 16 8C16 6.98492 15.7978 6.01454 15.4305 5.12886C15.0513 4.21436 14.4969 3.39207 13.8099 2.70336C13.1185 2.01021 12.2915 1.45115 11.3712 1.06949C10.4855 0.702212 9.51509 0.5 8.5 0.5C7.48491 0.5 6.51453 0.702212 5.62884 1.06949C4.71141 1.44993 3.88677 2.00663 3.1967 2.69669C2.50663 3.38676 1.94993 4.21142 1.56948 5.12886C1.35793 5.63902 1.6 6.22408 2.11016 6.43564C2.62032 6.64719 3.20539 6.40512 3.41694 5.89496C3.69537 5.22351 4.10357 4.61825 4.61092 4.11091C5.11825 3.60358 5.72351 3.19538 6.39494 2.91694C7.04205 2.6486 7.75241 2.5 8.5 2.5Z" />
    </g>
  ),
})

export const UserGroupIcon = makeIcon({
  displayName: 'UserGroupIcon',
  viewBox: 12,
  content: (
    <React.Fragment>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25 1.5C7.42157 1.5 6.75 2.17157 6.75 3C6.75 3.82843 7.42157 4.5 8.25 4.5C9.07843 4.5 9.75 3.82843 9.75 3C9.75 2.17157 9.07843 1.5 8.25 1.5ZM5.25 3C5.25 1.34315 6.59315 0 8.25 0C9.90685 0 11.25 1.34315 11.25 3C11.25 4.65685 9.90685 6 8.25 6C6.59315 6 5.25 4.65685 5.25 3Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.26251 2.625C2.64119 2.625 2.13751 3.12868 2.13751 3.75C2.13751 4.37132 2.64119 4.875 3.26251 4.875C3.51668 4.875 3.74922 4.79161 3.93719 4.65038C4.26835 4.40157 4.73851 4.46833 4.98732 4.79949C5.23612 5.13066 5.16936 5.60081 4.8382 5.84962C4.39937 6.17933 3.85271 6.375 3.26251 6.375C1.81276 6.375 0.637512 5.19975 0.637512 3.75C0.637512 2.30025 1.81276 1.125 3.26251 1.125C3.44133 1.125 3.61671 1.14299 3.78671 1.1775C4.19265 1.2599 4.45492 1.65577 4.37252 2.06171C4.29012 2.46764 3.89425 2.72992 3.48831 2.64752C3.41598 2.63283 3.34055 2.625 3.26251 2.625Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5625 8.25H6.9375C6.52248 8.25 6 8.64706 6 9.375V9.75C6 10.2708 6.36658 10.5 6.58929 10.5H9.91071C10.1334 10.5 10.5 10.2708 10.5 9.75V9.375C10.5 8.64706 9.97752 8.25 9.5625 8.25ZM9.5625 6.75H6.9375C5.59131 6.75 4.5 7.92525 4.5 9.375V9.75C4.5 10.9926 5.43541 12 6.58929 12H9.91071C11.0646 12 12 10.9926 12 9.75V9.375C12 7.92525 10.9087 6.75 9.5625 6.75Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25 8.625C1.83579 8.625 1.5 8.96079 1.5 9.375V10.125C1.5 10.3321 1.66789 10.5 1.875 10.5H3.375C3.78921 10.5 4.125 10.8358 4.125 11.25C4.125 11.6642 3.78921 12 3.375 12H1.875C0.839466 12 0 11.1605 0 10.125V9.375C0 8.13236 1.00736 7.125 2.25 7.125H3.375C3.78921 7.125 4.125 7.46079 4.125 7.875C4.125 8.28921 3.78921 8.625 3.375 8.625H2.25Z"
      />
    </React.Fragment>
  ),
})

export const UserAddIcon = makeIcon({
  displayName: 'UserAddIcon',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 8C5.79086 8 4 6.20914 4 4C4 1.79086 5.79086 0 8 0C10.2091 0 12 1.79086 12 4C12 6.20914 10.2091 8 8 8ZM8 6C9.10457 6 10 5.10457 10 4C10 2.89543 9.10457 2 8 2C6.89543 2 6 2.89543 6 4C6 5.10457 6.89543 6 8 6ZM8 11C8.55228 11 9 10.5523 9 10C9 9.44771 8.55228 9 8 9H3.5C1.567 9 0 10.567 0 12.5V13C0 14.6569 1.34315 16 3 16H8C8.55228 16 9 15.5523 9 15C9 14.4477 8.55228 14 8 14H3C2.44772 14 2 13.5523 2 13V12.5C2 11.6716 2.67157 11 3.5 11H8ZM11.625 9.875C11.625 9.39175 12.0168 9 12.5 9C12.9832 9 13.375 9.39175 13.375 9.875V11.625H15.125C15.6082 11.625 16 12.0168 16 12.5C16 12.9832 15.6082 13.375 15.125 13.375H13.375V15.125C13.375 15.6082 12.9832 16 12.5 16C12.0168 16 11.625 15.6082 11.625 15.125V13.375H9.875C9.39175 13.375 9 12.9832 9 12.5C9 12.0168 9.39175 11.625 9.875 11.625H11.625V9.875Z"
    />
  ),
})

export const WarningIcon = makeIcon({
  displayName: 'WarningIcon',
  content: (
    <path d="M8 0c4.4 0 8 3.6 8 8s-3.6 8-8 8-8-3.6-8-8 3.6-8 8-8zm0 2C4.7 2 2 4.7 2 8s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm0 7.3c-.6 0-1-.4-1-1V4.6c0-.6.4-1 1-1s1 .4 1 1v3.7c0 .6-.4 1-1 1zm0 3c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z" />
  ),
})

export const WindowsIcon = makeIcon({
  displayName: 'WindowIcon',
  viewBox: 9,
  content: (
    <path d="M0 1.3L3.7.8v3.5H0v-3zm3.7 3.4v3.5L0 7.7v-3h3.7zm.4-4L8.9 0v4.2H4.1V.7zm4.8 4V9l-4.8-.7V4.8l4.8-.1z" />
  ),
})

export const GlobeIcon = makeIcon({
  displayName: 'GlobeIcon',
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8ZM11.9547 9H13.917C13.6012 10.8827 12.4086 12.468 10.7735 13.3219C11.3164 12.1191 11.8064 10.6366 11.9547 9ZM11.9547 7H13.917C13.6012 5.11734 12.4086 3.53198 10.7735 2.6781C11.3164 3.88094 11.8064 5.36341 11.9547 7ZM8.16399 2.0022C8.30815 2.24284 8.45949 2.51095 8.61087 2.80315C9.19919 3.93878 9.76714 5.39808 9.94315 7H6.05444C6.23045 5.39808 6.7984 3.93878 7.38672 2.80315C7.53808 2.51098 7.68941 2.24289 7.83355 2.00226C7.88885 2.00076 7.94434 2 8 2C8.05484 2 8.10951 2.00074 8.16399 2.0022ZM5.22752 2.67758C3.59187 3.53134 2.39887 5.11697 2.08296 7H4.04606C4.19438 5.36318 4.68447 3.88051 5.22752 2.67758ZM4.04606 9H2.08296C2.39887 10.883 3.59188 12.4687 5.22752 13.3224C4.68447 12.1195 4.19438 10.6368 4.04606 9ZM8.16399 13.9978C8.10951 13.9993 8.05484 14 8 14C7.94434 14 7.88885 13.9992 7.83355 13.9977C7.68941 13.7571 7.53808 13.489 7.38672 13.1969C6.7984 12.0612 6.23045 10.6019 6.05444 9H9.94315C9.76714 10.6019 9.19919 12.0612 8.61087 13.1969C8.45949 13.489 8.30815 13.7572 8.16399 13.9978Z"
    />
  ),
})
